/**
 * @license
 * Copyright 2019 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */const lt=globalThis,Et=lt.ShadowRoot&&(lt.ShadyCSS===void 0||lt.ShadyCSS.nativeShadow)&&"adoptedStyleSheets"in Document.prototype&&"replace"in CSSStyleSheet.prototype,Ot=Symbol(),zt=new WeakMap;let Vt=class{constructor(t,i,r){if(this._$cssResult$=!0,r!==Ot)throw Error("CSSResult is not constructable. Use `unsafeCSS` or `css` instead.");this.cssText=t,this.t=i}get styleSheet(){let t=this.o;const i=this.t;if(Et&&t===void 0){const r=i!==void 0&&i.length===1;r&&(t=zt.get(i)),t===void 0&&((this.o=t=new CSSStyleSheet).replaceSync(this.cssText),r&&zt.set(i,t))}return t}toString(){return this.cssText}};const re=e=>new Vt(typeof e=="string"?e:e+"",void 0,Ot),A=(e,...t)=>{const i=e.length===1?e[0]:t.reduce((r,s,o)=>r+(n=>{if(n._$cssResult$===!0)return n.cssText;if(typeof n=="number")return n;throw Error("Value passed to 'css' function must be a 'css' function result: "+n+". Use 'unsafeCSS' to pass non-literal values, but take care to ensure page security.")})(s)+e[o+1],e[0]);return new Vt(i,e,Ot)},oe=(e,t)=>{if(Et)e.adoptedStyleSheets=t.map(i=>i instanceof CSSStyleSheet?i:i.styleSheet);else for(const i of t){const r=document.createElement("style"),s=lt.litNonce;s!==void 0&&r.setAttribute("nonce",s),r.textContent=i.cssText,e.appendChild(r)}},It=Et?e=>e:e=>e instanceof CSSStyleSheet?(t=>{let i="";for(const r of t.cssRules)i+=r.cssText;return re(i)})(e):e;/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */const{is:ne,defineProperty:ae,getOwnPropertyDescriptor:le,getOwnPropertyNames:ce,getOwnPropertySymbols:de,getPrototypeOf:pe}=Object,T=globalThis,Mt=T.trustedTypes,ue=Mt?Mt.emptyScript:"",_t=T.reactiveElementPolyfillSupport,Y=(e,t)=>e,ct={toAttribute(e,t){switch(t){case Boolean:e=e?ue:null;break;case Object:case Array:e=e==null?e:JSON.stringify(e)}return e},fromAttribute(e,t){let i=e;switch(t){case Boolean:i=e!==null;break;case Number:i=e===null?null:Number(e);break;case Object:case Array:try{i=JSON.parse(e)}catch{i=null}}return i}},jt=(e,t)=>!ne(e,t),Nt={attribute:!0,type:String,converter:ct,reflect:!1,hasChanged:jt};Symbol.metadata??(Symbol.metadata=Symbol("metadata")),T.litPropertyMetadata??(T.litPropertyMetadata=new WeakMap);class H extends HTMLElement{static addInitializer(t){this._$Ei(),(this.l??(this.l=[])).push(t)}static get observedAttributes(){return this.finalize(),this._$Eh&&[...this._$Eh.keys()]}static createProperty(t,i=Nt){if(i.state&&(i.attribute=!1),this._$Ei(),this.elementProperties.set(t,i),!i.noAccessor){const r=Symbol(),s=this.getPropertyDescriptor(t,r,i);s!==void 0&&ae(this.prototype,t,s)}}static getPropertyDescriptor(t,i,r){const{get:s,set:o}=le(this.prototype,t)??{get(){return this[i]},set(n){this[i]=n}};return{get(){return s==null?void 0:s.call(this)},set(n){const c=s==null?void 0:s.call(this);o.call(this,n),this.requestUpdate(t,c,r)},configurable:!0,enumerable:!0}}static getPropertyOptions(t){return this.elementProperties.get(t)??Nt}static _$Ei(){if(this.hasOwnProperty(Y("elementProperties")))return;const t=pe(this);t.finalize(),t.l!==void 0&&(this.l=[...t.l]),this.elementProperties=new Map(t.elementProperties)}static finalize(){if(this.hasOwnProperty(Y("finalized")))return;if(this.finalized=!0,this._$Ei(),this.hasOwnProperty(Y("properties"))){const i=this.properties,r=[...ce(i),...de(i)];for(const s of r)this.createProperty(s,i[s])}const t=this[Symbol.metadata];if(t!==null){const i=litPropertyMetadata.get(t);if(i!==void 0)for(const[r,s]of i)this.elementProperties.set(r,s)}this._$Eh=new Map;for(const[i,r]of this.elementProperties){const s=this._$Eu(i,r);s!==void 0&&this._$Eh.set(s,i)}this.elementStyles=this.finalizeStyles(this.styles)}static finalizeStyles(t){const i=[];if(Array.isArray(t)){const r=new Set(t.flat(1/0).reverse());for(const s of r)i.unshift(It(s))}else t!==void 0&&i.push(It(t));return i}static _$Eu(t,i){const r=i.attribute;return r===!1?void 0:typeof r=="string"?r:typeof t=="string"?t.toLowerCase():void 0}constructor(){super(),this._$Ep=void 0,this.isUpdatePending=!1,this.hasUpdated=!1,this._$Em=null,this._$Ev()}_$Ev(){var t;this._$ES=new Promise(i=>this.enableUpdating=i),this._$AL=new Map,this._$E_(),this.requestUpdate(),(t=this.constructor.l)==null||t.forEach(i=>i(this))}addController(t){var i;(this._$EO??(this._$EO=new Set)).add(t),this.renderRoot!==void 0&&this.isConnected&&((i=t.hostConnected)==null||i.call(t))}removeController(t){var i;(i=this._$EO)==null||i.delete(t)}_$E_(){const t=new Map,i=this.constructor.elementProperties;for(const r of i.keys())this.hasOwnProperty(r)&&(t.set(r,this[r]),delete this[r]);t.size>0&&(this._$Ep=t)}createRenderRoot(){const t=this.shadowRoot??this.attachShadow(this.constructor.shadowRootOptions);return oe(t,this.constructor.elementStyles),t}connectedCallback(){var t;this.renderRoot??(this.renderRoot=this.createRenderRoot()),this.enableUpdating(!0),(t=this._$EO)==null||t.forEach(i=>{var r;return(r=i.hostConnected)==null?void 0:r.call(i)})}enableUpdating(t){}disconnectedCallback(){var t;(t=this._$EO)==null||t.forEach(i=>{var r;return(r=i.hostDisconnected)==null?void 0:r.call(i)})}attributeChangedCallback(t,i,r){this._$AK(t,r)}_$EC(t,i){var o;const r=this.constructor.elementProperties.get(t),s=this.constructor._$Eu(t,r);if(s!==void 0&&r.reflect===!0){const n=(((o=r.converter)==null?void 0:o.toAttribute)!==void 0?r.converter:ct).toAttribute(i,r.type);this._$Em=t,n==null?this.removeAttribute(s):this.setAttribute(s,n),this._$Em=null}}_$AK(t,i){var o;const r=this.constructor,s=r._$Eh.get(t);if(s!==void 0&&this._$Em!==s){const n=r.getPropertyOptions(s),c=typeof n.converter=="function"?{fromAttribute:n.converter}:((o=n.converter)==null?void 0:o.fromAttribute)!==void 0?n.converter:ct;this._$Em=s,this[s]=c.fromAttribute(i,n.type),this._$Em=null}}requestUpdate(t,i,r){if(t!==void 0){if(r??(r=this.constructor.getPropertyOptions(t)),!(r.hasChanged??jt)(this[t],i))return;this.P(t,i,r)}this.isUpdatePending===!1&&(this._$ES=this._$ET())}P(t,i,r){this._$AL.has(t)||this._$AL.set(t,i),r.reflect===!0&&this._$Em!==t&&(this._$Ej??(this._$Ej=new Set)).add(t)}async _$ET(){this.isUpdatePending=!0;try{await this._$ES}catch(i){Promise.reject(i)}const t=this.scheduleUpdate();return t!=null&&await t,!this.isUpdatePending}scheduleUpdate(){return this.performUpdate()}performUpdate(){var r;if(!this.isUpdatePending)return;if(!this.hasUpdated){if(this.renderRoot??(this.renderRoot=this.createRenderRoot()),this._$Ep){for(const[o,n]of this._$Ep)this[o]=n;this._$Ep=void 0}const s=this.constructor.elementProperties;if(s.size>0)for(const[o,n]of s)n.wrapped!==!0||this._$AL.has(o)||this[o]===void 0||this.P(o,this[o],n)}let t=!1;const i=this._$AL;try{t=this.shouldUpdate(i),t?(this.willUpdate(i),(r=this._$EO)==null||r.forEach(s=>{var o;return(o=s.hostUpdate)==null?void 0:o.call(s)}),this.update(i)):this._$EU()}catch(s){throw t=!1,this._$EU(),s}t&&this._$AE(i)}willUpdate(t){}_$AE(t){var i;(i=this._$EO)==null||i.forEach(r=>{var s;return(s=r.hostUpdated)==null?void 0:s.call(r)}),this.hasUpdated||(this.hasUpdated=!0,this.firstUpdated(t)),this.updated(t)}_$EU(){this._$AL=new Map,this.isUpdatePending=!1}get updateComplete(){return this.getUpdateComplete()}getUpdateComplete(){return this._$ES}shouldUpdate(t){return!0}update(t){this._$Ej&&(this._$Ej=this._$Ej.forEach(i=>this._$EC(i,this[i]))),this._$EU()}updated(t){}firstUpdated(t){}}H.elementStyles=[],H.shadowRootOptions={mode:"open"},H[Y("elementProperties")]=new Map,H[Y("finalized")]=new Map,_t==null||_t({ReactiveElement:H}),(T.reactiveElementVersions??(T.reactiveElementVersions=[])).push("2.0.4");/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */const Q=globalThis,dt=Q.trustedTypes,Ut=dt?dt.createPolicy("lit-html",{createHTML:e=>e}):void 0,Wt="$lit$",j=`lit$${Math.random().toFixed(9).slice(2)}$`,Ft="?"+j,he=`<${Ft}>`,N=document,X=()=>N.createComment(""),Z=e=>e===null||typeof e!="object"&&typeof e!="function",Tt=Array.isArray,fe=e=>Tt(e)||typeof(e==null?void 0:e[Symbol.iterator])=="function",$t=`[ 	
\f\r]`,K=/<(?:(!--|\/[^a-zA-Z])|(\/?[a-zA-Z][^>\s]*)|(\/?$))/g,Rt=/-->/g,qt=/>/g,I=RegExp(`>|${$t}(?:([^\\s"'>=/]+)(${$t}*=${$t}*(?:[^ 	
\f\r"'\`<>=]|("|')|))|$)`,"g"),kt=/'/g,Ht=/"/g,Kt=/^(?:script|style|textarea|title)$/i,me=e=>(t,...i)=>({_$litType$:e,strings:t,values:i}),l=me(1),U=Symbol.for("lit-noChange"),h=Symbol.for("lit-nothing"),Jt=new WeakMap,M=N.createTreeWalker(N,129);function Yt(e,t){if(!Tt(e)||!e.hasOwnProperty("raw"))throw Error("invalid template strings array");return Ut!==void 0?Ut.createHTML(t):t}const ge=(e,t)=>{const i=e.length-1,r=[];let s,o=t===2?"<svg>":t===3?"<math>":"",n=K;for(let c=0;c<i;c++){const a=e[c];let u,m,p=-1,S=0;for(;S<a.length&&(n.lastIndex=S,m=n.exec(a),m!==null);)S=n.lastIndex,n===K?m[1]==="!--"?n=Rt:m[1]!==void 0?n=qt:m[2]!==void 0?(Kt.test(m[2])&&(s=RegExp("</"+m[2],"g")),n=I):m[3]!==void 0&&(n=I):n===I?m[0]===">"?(n=s??K,p=-1):m[1]===void 0?p=-2:(p=n.lastIndex-m[2].length,u=m[1],n=m[3]===void 0?I:m[3]==='"'?Ht:kt):n===Ht||n===kt?n=I:n===Rt||n===qt?n=K:(n=I,s=void 0);const O=n===I&&e[c+1].startsWith("/>")?" ":"";o+=n===K?a+he:p>=0?(r.push(u),a.slice(0,p)+Wt+a.slice(p)+j+O):a+j+(p===-2?c:O)}return[Yt(e,o+(e[i]||"<?>")+(t===2?"</svg>":t===3?"</math>":"")),r]};class tt{constructor({strings:t,_$litType$:i},r){let s;this.parts=[];let o=0,n=0;const c=t.length-1,a=this.parts,[u,m]=ge(t,i);if(this.el=tt.createElement(u,r),M.currentNode=this.el.content,i===2||i===3){const p=this.el.content.firstChild;p.replaceWith(...p.childNodes)}for(;(s=M.nextNode())!==null&&a.length<c;){if(s.nodeType===1){if(s.hasAttributes())for(const p of s.getAttributeNames())if(p.endsWith(Wt)){const S=m[n++],O=s.getAttribute(p).split(j),at=/([.?@])?(.*)/.exec(S);a.push({type:1,index:o,name:at[2],strings:O,ctor:at[1]==="."?be:at[1]==="?"?ve:at[1]==="@"?_e:ft}),s.removeAttribute(p)}else p.startsWith(j)&&(a.push({type:6,index:o}),s.removeAttribute(p));if(Kt.test(s.tagName)){const p=s.textContent.split(j),S=p.length-1;if(S>0){s.textContent=dt?dt.emptyScript:"";for(let O=0;O<S;O++)s.append(p[O],X()),M.nextNode(),a.push({type:2,index:++o});s.append(p[S],X())}}}else if(s.nodeType===8)if(s.data===Ft)a.push({type:2,index:o});else{let p=-1;for(;(p=s.data.indexOf(j,p+1))!==-1;)a.push({type:7,index:o}),p+=j.length-1}o++}}static createElement(t,i){const r=N.createElement("template");return r.innerHTML=t,r}}function J(e,t,i=e,r){var n,c;if(t===U)return t;let s=r!==void 0?(n=i._$Co)==null?void 0:n[r]:i._$Cl;const o=Z(t)?void 0:t._$litDirective$;return(s==null?void 0:s.constructor)!==o&&((c=s==null?void 0:s._$AO)==null||c.call(s,!1),o===void 0?s=void 0:(s=new o(e),s._$AT(e,i,r)),r!==void 0?(i._$Co??(i._$Co=[]))[r]=s:i._$Cl=s),s!==void 0&&(t=J(e,s._$AS(e,t.values),s,r)),t}class ye{constructor(t,i){this._$AV=[],this._$AN=void 0,this._$AD=t,this._$AM=i}get parentNode(){return this._$AM.parentNode}get _$AU(){return this._$AM._$AU}u(t){const{el:{content:i},parts:r}=this._$AD,s=((t==null?void 0:t.creationScope)??N).importNode(i,!0);M.currentNode=s;let o=M.nextNode(),n=0,c=0,a=r[0];for(;a!==void 0;){if(n===a.index){let u;a.type===2?u=new st(o,o.nextSibling,this,t):a.type===1?u=new a.ctor(o,a.name,a.strings,this,t):a.type===6&&(u=new $e(o,this,t)),this._$AV.push(u),a=r[++c]}n!==(a==null?void 0:a.index)&&(o=M.nextNode(),n++)}return M.currentNode=N,s}p(t){let i=0;for(const r of this._$AV)r!==void 0&&(r.strings!==void 0?(r._$AI(t,r,i),i+=r.strings.length-2):r._$AI(t[i])),i++}}class st{get _$AU(){var t;return((t=this._$AM)==null?void 0:t._$AU)??this._$Cv}constructor(t,i,r,s){this.type=2,this._$AH=h,this._$AN=void 0,this._$AA=t,this._$AB=i,this._$AM=r,this.options=s,this._$Cv=(s==null?void 0:s.isConnected)??!0}get parentNode(){let t=this._$AA.parentNode;const i=this._$AM;return i!==void 0&&(t==null?void 0:t.nodeType)===11&&(t=i.parentNode),t}get startNode(){return this._$AA}get endNode(){return this._$AB}_$AI(t,i=this){t=J(this,t,i),Z(t)?t===h||t==null||t===""?(this._$AH!==h&&this._$AR(),this._$AH=h):t!==this._$AH&&t!==U&&this._(t):t._$litType$!==void 0?this.$(t):t.nodeType!==void 0?this.T(t):fe(t)?this.k(t):this._(t)}O(t){return this._$AA.parentNode.insertBefore(t,this._$AB)}T(t){this._$AH!==t&&(this._$AR(),this._$AH=this.O(t))}_(t){this._$AH!==h&&Z(this._$AH)?this._$AA.nextSibling.data=t:this.T(N.createTextNode(t)),this._$AH=t}$(t){var o;const{values:i,_$litType$:r}=t,s=typeof r=="number"?this._$AC(t):(r.el===void 0&&(r.el=tt.createElement(Yt(r.h,r.h[0]),this.options)),r);if(((o=this._$AH)==null?void 0:o._$AD)===s)this._$AH.p(i);else{const n=new ye(s,this),c=n.u(this.options);n.p(i),this.T(c),this._$AH=n}}_$AC(t){let i=Jt.get(t.strings);return i===void 0&&Jt.set(t.strings,i=new tt(t)),i}k(t){Tt(this._$AH)||(this._$AH=[],this._$AR());const i=this._$AH;let r,s=0;for(const o of t)s===i.length?i.push(r=new st(this.O(X()),this.O(X()),this,this.options)):r=i[s],r._$AI(o),s++;s<i.length&&(this._$AR(r&&r._$AB.nextSibling,s),i.length=s)}_$AR(t=this._$AA.nextSibling,i){var r;for((r=this._$AP)==null?void 0:r.call(this,!1,!0,i);t&&t!==this._$AB;){const s=t.nextSibling;t.remove(),t=s}}setConnected(t){var i;this._$AM===void 0&&(this._$Cv=t,(i=this._$AP)==null||i.call(this,t))}}class ft{get tagName(){return this.element.tagName}get _$AU(){return this._$AM._$AU}constructor(t,i,r,s,o){this.type=1,this._$AH=h,this._$AN=void 0,this.element=t,this.name=i,this._$AM=s,this.options=o,r.length>2||r[0]!==""||r[1]!==""?(this._$AH=Array(r.length-1).fill(new String),this.strings=r):this._$AH=h}_$AI(t,i=this,r,s){const o=this.strings;let n=!1;if(o===void 0)t=J(this,t,i,0),n=!Z(t)||t!==this._$AH&&t!==U,n&&(this._$AH=t);else{const c=t;let a,u;for(t=o[0],a=0;a<o.length-1;a++)u=J(this,c[r+a],i,a),u===U&&(u=this._$AH[a]),n||(n=!Z(u)||u!==this._$AH[a]),u===h?t=h:t!==h&&(t+=(u??"")+o[a+1]),this._$AH[a]=u}n&&!s&&this.j(t)}j(t){t===h?this.element.removeAttribute(this.name):this.element.setAttribute(this.name,t??"")}}class be extends ft{constructor(){super(...arguments),this.type=3}j(t){this.element[this.name]=t===h?void 0:t}}class ve extends ft{constructor(){super(...arguments),this.type=4}j(t){this.element.toggleAttribute(this.name,!!t&&t!==h)}}class _e extends ft{constructor(t,i,r,s,o){super(t,i,r,s,o),this.type=5}_$AI(t,i=this){if((t=J(this,t,i,0)??h)===U)return;const r=this._$AH,s=t===h&&r!==h||t.capture!==r.capture||t.once!==r.once||t.passive!==r.passive,o=t!==h&&(r===h||s);s&&this.element.removeEventListener(this.name,this,r),o&&this.element.addEventListener(this.name,this,t),this._$AH=t}handleEvent(t){var i;typeof this._$AH=="function"?this._$AH.call(((i=this.options)==null?void 0:i.host)??this.element,t):this._$AH.handleEvent(t)}}class $e{constructor(t,i,r){this.element=t,this.type=6,this._$AN=void 0,this._$AM=i,this.options=r}get _$AU(){return this._$AM._$AU}_$AI(t){J(this,t)}}const xt=Q.litHtmlPolyfillSupport;xt==null||xt(tt,st),(Q.litHtmlVersions??(Q.litHtmlVersions=[])).push("3.2.1");const xe=(e,t,i)=>{const r=(i==null?void 0:i.renderBefore)??t;let s=r._$litPart$;if(s===void 0){const o=(i==null?void 0:i.renderBefore)??null;r._$litPart$=s=new st(t.insertBefore(X(),o),o,void 0,i??{})}return s._$AI(e),s};/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */let g=class extends H{constructor(){super(...arguments),this.renderOptions={host:this},this._$Do=void 0}createRenderRoot(){var i;const t=super.createRenderRoot();return(i=this.renderOptions).renderBefore??(i.renderBefore=t.firstChild),t}update(t){const i=this.render();this.hasUpdated||(this.renderOptions.isConnected=this.isConnected),super.update(t),this._$Do=xe(i,this.renderRoot,this.renderOptions)}connectedCallback(){var t;super.connectedCallback(),(t=this._$Do)==null||t.setConnected(!0)}disconnectedCallback(){var t;super.disconnectedCallback(),(t=this._$Do)==null||t.setConnected(!1)}render(){return U}};var Gt;g._$litElement$=!0,g.finalized=!0,(Gt=globalThis.litElementHydrateSupport)==null||Gt.call(globalThis,{LitElement:g});const wt=globalThis.litElementPolyfillSupport;wt==null||wt({LitElement:g});(globalThis.litElementVersions??(globalThis.litElementVersions=[])).push("4.1.1");/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */const v=e=>(t,i)=>{i!==void 0?i.addInitializer(()=>{customElements.define(e,t)}):customElements.define(e,t)};/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */const we={attribute:!0,type:String,converter:ct,reflect:!1,hasChanged:jt},Se=(e=we,t,i)=>{const{kind:r,metadata:s}=i;let o=globalThis.litPropertyMetadata.get(s);if(o===void 0&&globalThis.litPropertyMetadata.set(s,o=new Map),o.set(i.name,e),r==="accessor"){const{name:n}=i;return{set(c){const a=t.get.call(this);t.set.call(this,c),this.requestUpdate(n,a,e)},init(c){return c!==void 0&&this.P(n,void 0,e),c}}}if(r==="setter"){const{name:n}=i;return function(c){const a=this[n];t.call(this,c),this.requestUpdate(n,a,e)}}throw Error("Unsupported decorator location: "+r)};function y(e){return(t,i)=>typeof i=="object"?Se(e,t,i):((r,s,o)=>{const n=s.hasOwnProperty(o);return s.constructor.createProperty(o,n?{...r,wrapped:!0}:r),n?Object.getOwnPropertyDescriptor(s,o):void 0})(e,t,i)}/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */function f(e){return y({...e,state:!0,attribute:!1})}const Ce=A`
  .notification {
    position: fixed;
    top: 30px;
    right: 30px;
    z-index: 9999;
    padding: 15px;
    border-radius: 5px;
    background-color: #323232;
    color: #ffffff;
    display: none;
    opacity: 0;
    transition:
      opacity 0.3s ease-in-out,
      transform 0.3s ease-in-out;
  }

  .notification.show {
    display: block;
    opacity: 1;
    transform: translateY(0);
  }

  .notification.success {
    background-color: #4caf50;
  }

  .notification.error {
    background-color: #f44336;
  }

  .notification.info {
    background-color: #2196f3;
  }

  .notification.warning {
    background-color: #ff9800;
  }
`;var Pe=Object.defineProperty,Ae=Object.getOwnPropertyDescriptor,mt=(e,t,i,r)=>{for(var s=r>1?void 0:r?Ae(t,i):t,o=e.length-1,n;o>=0;o--)(n=e[o])&&(s=(r?n(t,i,s):n(s))||s);return r&&s&&Pe(t,i,s),s};let B=class extends g{constructor(){super(...arguments),this.type="info",this.message="",this.visible=!1}firstUpdated(){this.visible&&this.showNotification()}showNotification(){var t;this.visible=!0,this.requestUpdate();const e=(t=this.shadowRoot)==null?void 0:t.querySelector(".notification");e&&(e.classList.add("show"),setTimeout(()=>{this.hideNotification()},3e3))}hideNotification(){var t;const e=(t=this.shadowRoot)==null?void 0:t.querySelector(".notification");e&&(e.classList.remove("show"),setTimeout(()=>{this.visible=!1,this.requestUpdate()},300))}render(){return l`
      <div class="notification ${this.type} ${this.visible?"show":""}">
        ${this.message}
      </div>
    `}};B.styles=Ce;mt([y({type:String})],B.prototype,"type",2);mt([y({type:String})],B.prototype,"message",2);mt([y({type:Boolean})],B.prototype,"visible",2);B=mt([v("global-notification")],B);function b(e,t="info"){const i=document.querySelector("global-notification");i&&(i.setAttribute("message",e),i.setAttribute("type",t),i.showNotification())}const Ee=A`
  :host {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100vw;
    height: 100vh;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 9999;
    background-color: var(--spinner-background-color, rgba(255, 255, 255, 1));
  }

  .loader {
    border: 4px solid rgba(0, 0, 0, 0.1);
    border-top: 4px solid #000000;
    border-radius: 50%;
    width: 40px;
    height: 40px;
    animation: spin 1s linear infinite;
  }

  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`;var Oe=Object.defineProperty,je=Object.getOwnPropertyDescriptor,Qt=(e,t,i,r)=>{for(var s=r>1?void 0:r?je(t,i):t,o=e.length-1,n;o>=0;o--)(n=e[o])&&(s=(r?n(t,i,s):n(s))||s);return r&&s&&Oe(t,i,s),s};let pt=class extends g{constructor(){super(...arguments),this.transparentBackground=!1}updated(e){e.has("transparentBackground")&&this.style.setProperty("--spinner-background-color",this.transparentBackground?"rgba(255, 255, 255, 0.5)":"rgba(255, 255, 255, 1)")}render(){return l`<div id="loader" class="loader"></div>`}};pt.styles=Ee;Qt([y({type:Boolean})],pt.prototype,"transparentBackground",2);pt=Qt([v("spinner-page")],pt);function Te(e){const t="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";let i="";for(let r=0;r<e;r++)i+=t.charAt(Math.floor(Math.random()*t.length));return i}function D(e){return class extends e{constructor(...t){if(e._instance)return e._instance;super(...t),e._instance=this}}}function d(e,...t){return function(i,r){Object.defineProperty(i,r,{get(){return e._instance||(e._instance=new e(...t)),e._instance},enumerable:!0,configurable:!0})}}const De={BASE_URL:"/",DEV:!1,JAKED_API_GATEWAY:"https://api-gateway.jaked.com/api/v1/cll0zl3pe001ppivgkc3r9b9l",JAKED_IDP_CLIENT_ID:"66f2dc8583f94617a8f99061",JAKED_IDP_MULTIPASS_URL:"https://api-mdw.jaked.com/v1/jaked/auth",JAKED_IDP_OAUTH_URL:"https://login.jaked.com/signIn",JAKED_IPD_API_KEY:"d84gfb1hQasc5z!nBBCtLJ1YJIlCSLnjJ",JAKED_IPD_API_URL:"https://api-idp.jaked.com/api/v1/65cf6a3179edd028010d7457",JAKED_SHOPIFY_STORE_URL:"https://jakedspa.myshopify.com",MODE:"development",PROD:!0,SSR:!1,VITE_THEME_PREFIX:"JAKED"};var Le=Object.defineProperty,ze=Object.getOwnPropertyDescriptor,Ie=(e,t,i,r)=>{for(var s=r>1?void 0:r?ze(t,i):t,o=e.length-1,n;o>=0;o--)(n=e[o])&&(s=(r?n(t,i,s):n(s))||s);return r&&s&&Le(t,i,s),s};let R=class{constructor(e){this.themePrefix=e||"JAKED"}getEnvVariable(e){return De[`${this.themePrefix}_${e}`]}get(e,t){const i=this.getEnvVariable(e);if(i==null){if(t!==void 0)return t;throw new Error(`Configuration key "${this.themePrefix}_${e}" not found`)}return typeof t=="boolean"||i==="true"||i==="false"?i==="true":typeof t=="number"||!isNaN(Number(i))?Number(i):typeof t=="string"?i:Array.isArray(t)?i.split(",").map(r=>r.trim()):i}};R=Ie([D],R);var Me=Object.defineProperty,Ne=Object.getOwnPropertyDescriptor,Ue=(e,t,i,r)=>{for(var s=r>1?void 0:r?Ne(t,i):t,o=e.length-1,n;o>=0;o--)(n=e[o])&&(s=(r?n(t,i,s):n(s))||s);return r&&s&&Me(t,i,s),s};let _=class{constructor(){this.translations={};const e=window.translations;this.translations=this.decodeAndParseTranslations(e)}decodeHtmlEntities(e){var i;return((i=new DOMParser().parseFromString(e,"text/html").documentElement.textContent)==null?void 0:i.replaceAll("=>",":").replace(/=&gt;/g,":"))||""}decodeAndParseTranslations(e){const t={};for(const[i,r]of Object.entries(e)){const s=this.decodeHtmlEntities(r);try{const o=JSON.parse(s);t[i]=o}catch(o){console.error(`Errore durante il parsing della stringa JSON per la chiave ${i}:`,o),t[i]=s}}return t}t(e,t,i){const r=e.split(".");let s=this.translations;for(const o of r)if(s[o])s=s[o];else return i||e;if(typeof s=="string"){if(t)for(const[o,n]of Object.entries(t)){const c=new RegExp(`{${o}}`,"g");s=s.replace(c,n)}return s}return i||e}};_=Ue([D],_);var Re=Object.defineProperty,qe=Object.getOwnPropertyDescriptor,ke=(e,t,i,r)=>{for(var s=r>1?void 0:r?qe(t,i):t,o=e.length-1,n;o>=0;o--)(n=e[o])&&(s=(r?n(t,i,s):n(s))||s);return r&&s&&Re(t,i,s),s};let Bt=class{async request(e,t,i=!1){try{const r=await fetch(e,{headers:{"Content-Type":"application/json",Accept:"application/json","X-Requested-With":"XMLHttpRequest"},...t});if(!r.ok)throw new Error(`HTTP error! status: ${r.status}`);const s=i?await r.text():await r.json();return i?JSON.parse(s):s&&typeof s=="object"&&"status"in s&&s.status!==200?null:s}catch(r){return console.error(`Error during request to ${e}:`,r),null}}async getCart(){return this.request("/cart.js",{method:"GET"})}async addToCart(e){const t={id:e.id.toString(),quantity:e.quantity||1,...e.properties&&{properties:e.properties},...e.selling_plan&&{selling_plan:e.selling_plan},...e.sections&&{sections:e.sections},...e.sections_url&&{sections_url:e.sections_url}};return this.request("/cart/add.js",{method:"POST",body:JSON.stringify(t)})}async addMultipleToCart(e){const t={items:e.map(i=>({id:i.id.toString(),quantity:i.quantity||1,...i.properties&&{properties:i.properties},...i.selling_plan&&{selling_plan:i.selling_plan}}))};return this.request("/cart/add.js",{method:"POST",body:JSON.stringify(t)})}async changeCartItem(e){const t={line:e.line,quantity:e.quantity,sections:e.sections,sections_url:e.sections_url};return this.request("/cart/change.js",{method:"POST",body:JSON.stringify(t)},!0)}async updateCart(e){const t={};return e.note!==void 0&&(t.note=e.note),e.attributes&&(t.attributes=e.attributes),this.request("/cart/change.js",{method:"POST",body:JSON.stringify(t)})}async clearCart(){return this.request("/cart/clear.js",{method:"POST"})}async removeCartItem(e,t=[],i=window.location.pathname){return this.changeCartItem({line:e,quantity:"0",sections:t,sections_url:i})}async updateCartNote(e){return this.updateCart({note:e})}async updateCartAttributes(e){return this.updateCart({attributes:e})}async updateItemQuantity(e,t,i=["main-cart","cart-bubble"],r=window.location.pathname){return this.changeCartItem({line:e,quantity:t,sections:i,sections_url:r})}async getCartItemCount(){const e=await this.getCart();return(e==null?void 0:e.item_count)||0}async getCartTotal(){const e=await this.getCart();return(e==null?void 0:e.total_price)||null}async isCartEmpty(){return await this.getCartItemCount()===0}async findLineItemByVariantId(e){const t=await this.getCart();if(!t)return null;const i=t.items.findIndex(s=>s.variant_id===e);if(i===-1)return null;const r=i+1;return{...t.items[i],line:r.toString()}}async updateLineItemProperties(e,t){const i={line:e,properties:t};return this.request("/cart/change.js",{method:"POST",body:JSON.stringify(i)})}};Bt=ke([D],Bt);var He=Object.defineProperty,Je=Object.getOwnPropertyDescriptor,Xt=(e,t,i,r)=>{for(var s=r>1?void 0:r?Je(t,i):t,o=e.length-1,n;o>=0;o--)(n=e[o])&&(s=(r?n(t,i,s):n(s))||s);return r&&s&&He(t,i,s),s};let St=class{async request(e,t){const i=this.configService.get("API_GATEWAY");try{const r=await fetch(`${i}${e}`,{credentials:"include",headers:{"Content-Type":"application/json"},...t}),s=await r.json();if(!r.ok&&s.error){const o=s.error.message||`Error ${s.error.statusCode}: ${s.error.error}`;return b(o,"error"),null}return s.data}catch(r){return console.error(`Error during request to ${e}:`,r),null}}async getCart(){const e="/cart",t={method:"GET"};return await this.request(e,t)}async checkout(e){const t="/cart/checkout",i={method:"POST",body:JSON.stringify(e)};return await this.request(t,i)}async createCart(e){const t="/cart",i={method:"POST",body:JSON.stringify(e)};return await this.request(t,i)}async syncCart(e){const t="/cart",i={method:"PUT",body:JSON.stringify(e)};return await this.request(t,i)}async addVariantToCart(e,t,i){const r=`/cart/${e}/${t}`,s={method:"PUT",body:JSON.stringify({giftcard:i})};return await this.request(r,s)}async removeVariantFromCart(e,t){const i=`/cart/${e}/${t}`,r={method:"DELETE"};return await this.request(i,r)}async removeAll(){const e="/cart",t={method:"DELETE"};return await this.request(e,t)}};Xt([d(R)],St.prototype,"configService",2);St=Xt([D],St);function gt(e){return class extends e{createRenderRoot(){return this}}}var Be=Object.defineProperty,Ge=Object.getOwnPropertyDescriptor,Zt=(e,t,i,r)=>{for(var s=r>1?void 0:r?Ge(t,i):t,o=e.length-1,n;o>=0;o--)(n=e[o])&&(s=(r?n(t,i,s):n(s))||s);return r&&s&&Be(t,i,s),s};let G=class{constructor(){}getQueryParameter(e){return new URLSearchParams(window.location.search).get(e)}async handleLogin(){const e=Te(32),t=this.configService.get("IDP_CLIENT_ID"),i=this.configService.get("IDP_OAUTH_URL"),r=this.configService.get("SHOPIFY_STORE_URL"),s=this.configService.get("IDP_MULTIPASS_URL"),o=`${r}/account/login`,n=`${i}?client_id=${t}&redirect_uri=${o}&response_type=code&state=${e}`,c=this.getQueryParameter("code");if(c)try{const a=await fetch(s,{method:"POST",headers:{"Content-Type":"application/json"},body:JSON.stringify({code:c})}),u=await a.json();if(a.ok){const m=`${r}/account/login/multipass/${u.multipassToken}`;window.location.href=m}else console.error("Errore nella risposta:",u)}catch(a){console.error("Errore durante la richiesta:",a)}else console.log("Redirect to IDP",n),window.location.href=n}};Zt([d(R)],G.prototype,"configService",2);G=Zt([D],G);var Ve=Object.defineProperty,We=Object.getOwnPropertyDescriptor,te=(e,t,i,r)=>{for(var s=r>1?void 0:r?We(t,i):t,o=e.length-1,n;o>=0;o--)(n=e[o])&&(s=(r?n(t,i,s):n(s))||s);return r&&s&&Ve(t,i,s),s};let Ct=class extends g{connectedCallback(){super.connectedCallback(),this.handleLogin()}async handleLogin(){try{await this.multipassService.handleLogin()}catch(e){console.error("Errore durante il login:",e)}}render(){return l`<spinner-page></spinner-page>`}};te([d(G)],Ct.prototype,"multipassService",2);Ct=te([v("idp-auth")],Ct);var Fe=Object.defineProperty,Ke=Object.getOwnPropertyDescriptor,yt=(e,t,i,r)=>{for(var s=r>1?void 0:r?Ke(t,i):t,o=e.length-1,n;o>=0;o--)(n=e[o])&&(s=(r?n(t,i,s):n(s))||s);return r&&s&&Fe(t,i,s),s};let x=class{async request(e,t){const i=this.configService.get("API_GATEWAY");try{const r=await fetch(`${i}${e}`,{credentials:"include",headers:{"Content-Type":"application/json"},...t}),s=await r.json();if(!r.ok&&s.error){const o=s.error.message||`Error ${s.error.statusCode}: ${s.error.error}`;return b(o,"error"),(s.error.statusCode===401||s.error.statusCode===403)&&this.multipassService.handleLogin(),null}return s.data}catch(r){return console.error(`Error during request to ${e}:`,r),null}}async me(){const e=await this.request("/users/profile",{method:"GET"});return{...e,birthdate:(e==null?void 0:e.birthdate.split("T")[0])??""}}async privacy(){return this.request("/privacy/policies",{method:"GET"})}async userConsent(){return this.request("/privacy/userConsent",{method:"GET"})}async updateUserConsent(e){const t=await this.request("/privacy/userConsent",{method:"PUT",body:JSON.stringify(e)});return t&&b(this.i18n.t("customer.account.profile_update_success"),"success"),t}async updateUserProfile(e){const t=await this.request("/users/profile",{method:"PATCH",body:JSON.stringify(e)});return t&&b(this.i18n.t("customer.account.profile_update_success"),"success"),t}async changePassword(e){const t=await this.request("/auth/changePassword",{method:"POST",body:JSON.stringify(e)});return t&&b(this.i18n.t("customer.password_change.success_message"),"success"),t}};yt([d(R)],x.prototype,"configService",2);yt([d(_)],x.prototype,"i18n",2);yt([d(G)],x.prototype,"multipassService",2);x=yt([D],x);var Ye=Object.defineProperty,Qe=Object.getOwnPropertyDescriptor,rt=(e,t,i,r)=>{for(var s=r>1?void 0:r?Qe(t,i):t,o=e.length-1,n;o>=0;o--)(n=e[o])&&(s=(r?n(t,i,s):n(s))||s);return r&&s&&Ye(t,i,s),s};const Xe=["+39","+1","+44","+33","+49","+34","+86","+81","+61","+55","+91","+7","+27","+31","+46","+47","+48","+351","+90","+82","+64","+60","+66","+32","+41","+45","+358","+353","+372","+30","+36","+40","+370","+371","+372","+420","+421","+386","+385","+389","+382","+370","+372","+386","+41"];let V=class extends g{constructor(){super(...arguments),this.user=null,this.isLoading=!1}handleInputChange(e){const t=e.target;this.user&&(t.name==="phone-prefix"?this.user.phone={...this.user.phone,prefix:t.value}:this.user={...this.user,[t.name]:t.value})}async handleSubmit(e){if(e.preventDefault(),this.user)try{this.isLoading=!0,await this.idpService.updateUserProfile(this.user),b(this.i18n.t("customer.account.profile_update_success"),"success")}catch{b(this.i18n.t("customer.account.profile_update_error"),"error")}finally{this.isLoading=!1}}handleLogout(){window.location.href="/account/logout"}render(){var e,t,i,r,s,o;return this.user?l`
      <form
        @submit="${this.handleSubmit}"
        style="width: 100%; display: flex; flex-direction: column; gap: 36px;"
      >
        ${this.isLoading?l`<spinner-page transparentBackground></spinner-page>`:null}

        <div
          class="form-control"
          style="display: flex; flex-direction: column;"
        >
          <input
            id="user-email"
            class="input"
            type="email"
            name="email"
            style="background-color: #f7f7f7; color: #888;"
            disabled
            .value="${((e=this.user)==null?void 0:e.email)||""}"
          />
        </div>

        <div
          class="form-control"
          style="position: relative; display: flex; flex-direction: column;"
        >
          <input
            id="user-firstname"
            class="input"
            type="text"
            name="firstName"
            placeholder="${this.i18n.t("customer.account.first_name")}"
            .value="${((t=this.user)==null?void 0:t.firstName)||""}"
            @input="${this.handleInputChange}"
            required
          />
          <label
            style="top: -28px; position: absolute; margin-bottom: 8px;"
            for="user-firstname"
            class="floating-label"
          >
            ${this.i18n.t("customer.account.first_name")}
          </label>
        </div>

        <div
          class="form-control"
          style="position: relative; display: flex; flex-direction: column;"
        >
          <input
            id="user-lastname"
            class="input"
            type="text"
            name="lastName"
            placeholder=" "
            .value="${((i=this.user)==null?void 0:i.lastName)||""}"
            @input="${this.handleInputChange}"
            required
          />
          <label
            for="user-lastname"
            style="top: -28px; position: absolute; margin-bottom: 8px;"
            class="floating-label"
          >
            ${this.i18n.t("customer.account.last_name")}
          </label>
        </div>

        <div
          class="form-control"
          style="position: relative; display: flex; flex-direction: column;"
        >
          <input
            id="user-birthdate"
            class="input"
            type="date"
            name="birthdate"
            placeholder=" "
            .value="${((r=this.user)==null?void 0:r.birthdate)||""}"
            @input="${this.handleInputChange}"
          />
          <label
            for="user-birthdate"
            style="top: -28px; position: absolute; margin-bottom: 8px;"
            class="floating-label"
          >
            ${this.i18n.t("customer.account.birthdate")}
          </label>
        </div>

        <div style="display: flex; align-items: flex-end; margin-top: 0;">
          <div
            class="form-control"
            style="flex: none; display: flex; flex-direction: column; position: relative;"
          >
            <select
              id="phone-prefix"
              name="phone-prefix"
              class="input"
              style="width: 100px; height: 42px; margin-right: 8px; box-sizing: border-box;"
              @change="${this.handleInputChange}"
            >
              ${Xe.map(n=>{var c,a;return l`<option
                    value="${n}"
                    ?selected="${((a=(c=this.user)==null?void 0:c.phone)==null?void 0:a.prefix)===n}"
                  >
                    ${n}
                  </option>`})}
            </select>
            <label
              for="user-phone"
              class="floating-label"
              style="top: -32px; position: absolute; margin-bottom: 8px;"
            >
              ${this.i18n.t("customer.account.phone")}
            </label>
          </div>

          <div
            class="form-control"
            style="flex-grow: 1; display: flex; flex-direction: column; position: relative;"
          >
            <input
              id="user-phone"
              type="tel"
              name="phone"
              placeholder=" "
              style="width: 100%;"
              .value="${((o=(s=this.user)==null?void 0:s.phone)==null?void 0:o.number)||""}"
              @input="${this.handleInputChange}"
            />
          </div>
        </div>

        <div class="display:flex; justify-content: space-between">
          <button
            type="submit"
            class="btn btn--primary button-row__btn"
            style="align-self: flex-start;"
          >
            ${this.i18n.t("customer.account.submit")}
          </button>
          <div
            @click="${this.handleLogout}"
            class="btn btn--secondary button-row__btn"
            style="align-self: flex-start"
          >
            ${this.i18n.t("customer.account.logout")}
          </div>
        </div>
      </form>
    `:l`<spinner-page></spinner-page>`}};rt([d(x)],V.prototype,"idpService",2);rt([d(_)],V.prototype,"i18n",2);rt([y({type:Object})],V.prototype,"user",2);rt([f()],V.prototype,"isLoading",2);V=rt([v("user-profile-form"),gt],V);var Ze=Object.defineProperty,ti=Object.getOwnPropertyDescriptor,L=(e,t,i,r)=>{for(var s=r>1?void 0:r?ti(t,i):t,o=e.length-1,n;o>=0;o--)(n=e[o])&&(s=(r?n(t,i,s):n(s))||s);return r&&s&&Ze(t,i,s),s};let C=class extends g{constructor(){super(...arguments),this.userConsent=null,this.mandatoryConsents=[],this.optionalConsents=[],this.isLoading=!0,this.isSaving=!1}async connectedCallback(){super.connectedCallback();const e=await this.idpService.privacy()??[];this.mandatoryConsents=e.filter(t=>t.isMandatory),this.optionalConsents=e.filter(t=>!t.isMandatory),this.userConsent=await this.idpService.userConsent(),this.isLoading=!1}handleConsentChange(e,t){this.userConsent&&(this.userConsent={...this.userConsent,consents:this.userConsent.consents.map(i=>i.privacyId===e?{...i,consent:t}:i)})}getConsent(e){var t,i;return((i=(t=this.userConsent)==null?void 0:t.consents.find(r=>e===r.privacy))==null?void 0:i.consent)??!1}async handleSubmit(e){if(e.preventDefault(),this.userConsent){this.isSaving=!0;try{const t=this.userConsent.consents.map(i=>({consent:i.consent,isMandatory:i.isMandatory,privacyId:i.privacyId,version:i.version}));await this.idpService.updateUserConsent(t)}catch{b(this.i18n.t("customer.account.profile_update_error"),"error")}finally{this.isSaving=!1}}}render(){return this.isLoading?l`<spinner-page transparentBackground></spinner-page>`:l`
      <div>
        ${this.isSaving?l`<spinner-page transparentBackground></spinner-page>`:null}
        <p>
          ${this.i18n.t("customer.account.viewed_and_accepted")}
          ${this.mandatoryConsents.map((e,t)=>l`
              <a
                href="${e.slug=="loyalty"?"https://tribe.jaked.com/static/regolamento-loyalty-tribe.pdf":"pages/terms-and-conditions"}"
                target="_blank"
                style="text-decoration: underline; color: inherit;"
              >
                ${this.i18n.t("customer.account."+e.slug)}</a
              >${t<this.mandatoryConsents.length-1?",":"."}
            `)}
        </p>

        <p class="customer-account-category h6 text-subdued">
          ${this.i18n.t("customer.account.data_protection")}
        </p>

        <div>
          <p>
            ${this.i18n.t("customer.account.privacy_policy_notice")}
            <a
              target="_blank"
              href="https://www.iubenda.com/privacy-policy/38303141"
              style="text-decoration: underline;"
            >
              ${this.i18n.t("customer.account.privacy_policy_link")}</a
            >:
          </p>

          ${this.optionalConsents.map(e=>l`
              <div style="margin-bottom: 15px;">
                <div style="margin-bottom: 5px;">
                  Autorizzo il trattamento dei miei dati per finalità di
                  ${this.i18n.t("customer.account."+e.slug)}
                </div>
                <div style="display: flex; align-items: center;">
                  <label style="display: flex; align-items: center;">
                    <input
                      type="checkbox"
                      name="${e.id}"
                      @change="${t=>this.handleConsentChange(e.id,t.target.checked)}"
                      ?checked="${this.getConsent(e.id)}"
                      style="margin-right: 5px;"
                    />
                    ${this.i18n.t("customer.account.give_consent")}
                  </label>
                </div>
              </div>
            `)}
        </div>

        <button
          type="submit"
          class="btn btn--primary button-row__btn"
          @click="${this.handleSubmit}"
          ?disabled="${this.isSaving}"
        >
          ${this.isSaving?"Salvando...":this.i18n.t("customer.account.submit")}
        </button>
      </div>
    `}};L([d(x)],C.prototype,"idpService",2);L([d(_)],C.prototype,"i18n",2);L([f()],C.prototype,"userConsent",2);L([f()],C.prototype,"mandatoryConsents",2);L([f()],C.prototype,"optionalConsents",2);L([f()],C.prototype,"isLoading",2);L([f()],C.prototype,"isSaving",2);C=L([v("user-privacy-form"),gt],C);var ei=Object.defineProperty,ii=Object.getOwnPropertyDescriptor,ot=(e,t,i,r)=>{for(var s=r>1?void 0:r?ii(t,i):t,o=e.length-1,n;o>=0;o--)(n=e[o])&&(s=(r?n(t,i,s):n(s))||s);return r&&s&&ei(t,i,s),s};let W=class extends g{constructor(){super(...arguments),this.dto=null,this.isLoading=!1}handleInputChange(e){const t=e.target;this.dto={...this.dto,[t.name]:t.value}}async handleSubmit(e){var i,r,s;if(e.preventDefault(),((i=this.dto)==null?void 0:i.confirmPassword)!==((r=this.dto)==null?void 0:r.password)){b(this.i18n.t("customer.password_change.error_password_mismatch"),"error");return}if(!/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^\w\s]).{8,}$/.test(((s=this.dto)==null?void 0:s.password)||"")){b(this.i18n.t("customer.password_change.error_password_invalid"),"error");return}try{this.isLoading=!0,await this.idpService.changePassword(this.dto),b(this.i18n.t("customer.password_change.success"),"success")}catch{b(this.i18n.t("customer.password_change.error_message"),"error")}finally{this.isLoading=!1,this.dto=null}}render(){return l`
      <form
        @submit="${this.handleSubmit}"
        style="width: 100%; display: flex; flex-direction: column; gap: 36px; padding-top:15px"
      >
        ${this.isLoading?l`<spinner-page transparentBackground></spinner-page>`:null}

        <div
          class="form-control"
          style="position: relative; display: flex; flex-direction: column;"
        >
          <input
            id="input--template--password-old"
            class="input"
            type="password"
            name="oldPassword"
            @input="${this.handleInputChange}"
            placeholder="${this.i18n.t("customer.password_change.old_password")}"
            autocomplete="current-password"
            required
          />
          <label
            style="top: -28px; position: absolute; margin-bottom: 8px;"
            for="input--template--password-old"
            class="floating-label"
          >
            ${this.i18n.t("customer.password_change.old_password")}
          </label>
        </div>

        <div
          class="form-control"
          style="position: relative; display: flex; flex-direction: column;"
        >
          <input
            id="input--template--password-new"
            class="input"
            type="password"
            name="password"
            @input="${this.handleInputChange}"
            placeholder="${this.i18n.t("customer.password_change.new_password")}"
            autocomplete="new-password"
            required
          />
          <label
            style="top: -28px; position: absolute; margin-bottom: 8px;"
            for="input--template--password-new"
            class="floating-label"
          >
            ${this.i18n.t("customer.password_change.new_password")}
          </label>
        </div>

        <div
          class="form-control"
          style="position: relative; display: flex; flex-direction: column;"
        >
          <input
            id="input--template--password-confirm"
            class="input"
            type="password"
            name="confirmPassword"
            @input="${this.handleInputChange}"
            placeholder="${this.i18n.t("customer.password_change.confirm_password")}"
            autocomplete="new-password"
            required
          />
          <label
            style="top: -28px; position: absolute; margin-bottom: 8px;"
            for="input--template--password-confirm"
            class="floating-label"
          >
            ${this.i18n.t("customer.password_change.confirm_password")}
          </label>
        </div>

        <div
          style="margin-top: 2px; font-size: 0.75rem; color: #555; line-height: 1.2; font-size:14px"
        >
          <strong>${this.i18n.t("customer.password_change.note")}</strong>
          <ul style="margin-top: 2px; padding-left: 15px; font-size:14px">
            <li>${this.i18n.t("customer.password_change.rule_1")}</li>
            <li>${this.i18n.t("customer.password_change.rule_2")}</li>
            <li>${this.i18n.t("customer.password_change.rule_3")}</li>
            <li>
              ${this.i18n.t("customer.password_change.rule_4")}
              ${"^ $ * . [ ] { } ( ) ? \" ! @ # % & / \\ , > < ' : ; | _ ~ ` = + -"}
            </li>
          </ul>
        </div>

        <button
          type="submit"
          class="btn btn--primary button-row__btn"
          style="align-self: flex-start;"
        >
          ${this.i18n.t("customer.password_change.save_button")}
        </button>
      </form>
    `}};ot([f()],W.prototype,"dto",2);ot([f()],W.prototype,"isLoading",2);ot([d(_)],W.prototype,"i18n",2);ot([d(x)],W.prototype,"idpService",2);W=ot([v("password-change-form"),gt],W);var si=Object.defineProperty,ri=Object.getOwnPropertyDescriptor,bt=(e,t,i,r)=>{for(var s=r>1?void 0:r?ri(t,i):t,o=e.length-1,n;o>=0;o--)(n=e[o])&&(s=(r?n(t,i,s):n(s))||s);return r&&s&&si(t,i,s),s};let F=class{async request(e,t){const i=this.configService.get("API_GATEWAY");try{const r=await fetch(`${i}${e}`,{credentials:"include",headers:{"Content-Type":"application/json"},...t}),s=await r.json();if(!r.ok&&s.error){const o=s.error.message||`Error ${s.error.statusCode}: ${s.error.error}`;return b(o,"error"),(s.error.statusCode===401||s.error.statusCode===403)&&this.multipassService.handleLogin(),null}return s.data}catch(r){return console.error(`Error during request to ${e}:`,r),null}}async getLevels(){return this.request("/loyalty/levels",{method:"GET"})}async getRewards(){return this.request("/loyalty/rewards",{method:"GET"})}async requireReward(e){return this.request(`/loyalty/${e}/require`,{method:"POST"})}async getActions(){return this.request("/loyalty/actions",{method:"GET"})}};bt([d(R)],F.prototype,"configService",2);bt([d(G)],F.prototype,"multipassService",2);bt([d(_)],F.prototype,"i18n",2);F=bt([D],F);const oi=A`
  .container {
    //border: 1px solid #d3d3d3;
    //border-radius: 8px;
    //padding: 30px;
    //padding-bottom: 15px;
    margin-bottom: 30px;
  }

  .profile-card {
    display: flex;
    flex-direction: column;
    margin-bottom: 1rem;
  }

  .profile-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 50px;
  }

  .profile-header img {
    width: 28px;
    height: 28px;
  }

  .profile-header p {
    font-size: 20px;
    margin: 0;
  }

  .progress-container {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-bottom: 10px;
    width: 100%;
    position: relative;
  }

  .progress-bar {
    display: flex;
    width: 100%;
    height: 5px;
    background-color: #d9d9d9;
    border-radius: 15px;
    overflow: hidden;
    position: relative;
  }

  .progress-inner {
    background-color: #f7fc00;
    height: 100%;
    border-radius: 15px;
    position: absolute;
    top: 0;
    left: 0;
  }

  .level-mark {
    z-index: 10;
    width: 15px;
    height: 15px;
    border-radius: 50%;
    margin-top: -6px;
    position: relative;
  }

  .btn {
    background-color: #000;
    height: 44px;
    color: #fff;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    width: 100%;
    border-radius: 3px;
    margin-right: 10px;
  }

  .btn:not(.secondary) {
    background-color: #000;
  }

  .button-row {
    padding-top: 20px;
    display: flex;
    justify-content: space-between;
    gap: 10px; /* Spaziatura tra i bottoni */
  }

  .level-text {
    position: absolute;
    top: -30px; /* Solleva l'etichetta sopra la barra */
    width: 100%;
    display: flex;
    justify-content: space-between; /* Distribuisce equamente le etichette */
    font-size: 13px;
  }

  .level-text span {
    text-align: center;
    white-space: nowrap; /* Mantiene il testo su una linea */
  }

  .level-point-container {
    display: flex;
    justify-content: space-between;
    margin-top: -13px;
  }

  .points-container {
    display: flex;
    flex-direction: column;
    justify-content: space-between; /* Distribuisce equamente i numeri */
    padding-top: 10px;
    font-size: 12px;
    color: #777781;
  }

  .points-container span {
    text-align: center;
    white-space: nowrap;
  }

  .modal-container {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    max-width: 350px;
  }

  .modal-title {
    padding-top: 15px;
    font-weight: 600;
    font-size: 22px;
  }

  .modal-point-container {
    width: 100%;
    justify-content: space-between;
    font-weight: 600;
    font-size: 18px;
    display: flex;
    padding: 15px;
    border-top: 1px solid #d3d3d3;
  }

  .modal-wrapper {
    justify-content: center;
    display: flex;
  }

  .modal-text {
    padding-top: 15px;
    text-align: center;
    color: #626266;
  }
`;/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */const ni={ATTRIBUTE:1,CHILD:2,PROPERTY:3,BOOLEAN_ATTRIBUTE:4,EVENT:5,ELEMENT:6},ai=e=>(...t)=>({_$litDirective$:e,values:t});class li{constructor(t){}get _$AU(){return this._$AM._$AU}_$AT(t,i,r){this._$Ct=t,this._$AM=i,this._$Ci=r}_$AS(t,i){return this.update(t,i)}update(t,i){return this.render(...i)}}/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */class Pt extends li{constructor(t){if(super(t),this.it=h,t.type!==ni.CHILD)throw Error(this.constructor.directiveName+"() can only be used in child bindings")}render(t){if(t===h||t==null)return this._t=void 0,this.it=t;if(t===U)return t;if(typeof t!="string")throw Error(this.constructor.directiveName+"() called with a non-string value");if(t===this.it)return this._t;this.it=t;const i=[t];return i.raw=i,this._t={_$litType$:this.constructor.resultType,strings:i,values:[]}}}Pt.directiveName="unsafeHTML",Pt.resultType=1;const Dt=ai(Pt);var ci=Object.defineProperty,di=Object.getOwnPropertyDescriptor,k=(e,t,i,r)=>{for(var s=r>1?void 0:r?di(t,i):t,o=e.length-1,n;o>=0;o--)(n=e[o])&&(s=(r?n(t,i,s):n(s))||s);return r&&s&&ci(t,i,s),s};let P=class extends g{constructor(){super(...arguments),this.user=null,this.levels=null,this.isModalOpen=!1}async connectedCallback(){super.connectedCallback(),this.levels=await this.fanizeService.getLevels()}calculateProgress(e){var s,o,n,c;const{currentLevelNum:t}=((o=(s=this.user)==null?void 0:s.loyalty)==null?void 0:o.level)||{},{points:i}=((c=(n=this.user)==null?void 0:n.loyalty)==null?void 0:c.stats)||{};if(!t||!i||!this.levels)return 0;let r=0;return t===e.levelNum?r=(i-e.min)/(e.max-e.min)*100:t>e.levelNum&&(r=100),r}openModal(){this.isModalOpen=!0}closeModal(){this.isModalOpen=!1}handlePointsProfileClick(){window.open("https://tribe.jaked.com/","_blank")}render(){if(!this.user||!this.levels||!this.user.loyalty)return l``;const e=this.user.loyalty;return l`
      <div class="container">
        <div class="profile-card">
          <div class="profile-header">
            <div style="display: flex; align-items: center; gap: 10px;">
              <img
                src="https://cdn.shopify.com/s/files/1/0893/8107/7341/files/loyalty-points.svg?v=1729258114"
                alt="Goccia Icon"
              />
              <p>
                ${Dt(this.i18n.t("customer.loyalty.you_have_drop_point",{points:`${e==null?void 0:e.stats.points.toString()}`}))}
              </p>
            </div>
            <a
              href="https://tribe.jaked.com/static/regolamento-loyalty-tribe.pdf"
              target="_blank"
              style="color: #0353a4; font-size: 14px;"
            >
              ${this.i18n.t("customer.loyalty.discover_tribe")}
            </a>
          </div>

          <!-- Progress Bar -->
          <div class="progress-container">
            <div class="level-text">
              ${this.levels.map(t=>l`
                  <span
                    style="color: ${(e==null?void 0:e.level.currentLevelNum)>=t.levelNum?"#000":"#777781"}; font-weight: ${(e==null?void 0:e.level.currentLevelNum)===t.levelNum?"bold":"normal"};"
                  >
                    ${t.label}
                  </span>
                `)}
            </div>
          </div>
          <div style="display: flex;">
            ${this.levels.map((t,i)=>{if(i===this.levels.length-1)return l``;const r=this.calculateProgress(t);return l`
                <div style="flex: 1; position: relative;">
                  <div class="progress-bar">
                    <div
                      class="progress-inner"
                      style="width: ${r}%"
                    ></div>
                  </div>
                </div>
              `})}
          </div>

          <!-- Punti associati ai livelli sotto i pallini -->
          <div class="points-container">
            <div class="level-point-container">
              ${this.levels.map(t=>t.levelNum!==1?l`
                      <div
                        class="level-mark"
                        style="background-color: ${(e==null?void 0:e.level.currentLevelNum)>=t.levelNum?"#F7FC00":"#777781"};"
                      ></div>
                    `:l`<span style="width:15px"></span>`)}
            </div>
            <br />
            <div class="level-point-container">
              ${this.levels.map(t=>l`
                  <span style="padding-left:20px"
                    >${t.min===0?"":t.min}</span
                  >
                `)}
            </div>
          </div>

          ${e!=null&&e.level.nextLevel?l`<div>
                <span>
                  ${this.i18n.t("customer.loyalty.missing_points")}
                  <b
                    >${e==null?void 0:e.level.pointsToNext}
                    ${this.i18n.t("customer.loyalty.points_goccia")}</b
                  >
                  ${this.i18n.t("customer.loyalty.for_next_level")}
                  <b>${e==null?void 0:e.level.nextLevel}</b>.
                  <br />
                  ${this.i18n.t("customer.loyalty.what_are_you_waiting_for")}
                </span>
              </div>`:l`<p>${this.i18n.t("customer.loyalty.highest_level")}</p>`}

          <!-- Button section -->
          <div class="button-row">
            <div class="btn" @click="${this.openModal}">
              ${this.i18n.t("customer.loyalty.view_loyalty_card")}
            </div>
            <div class="btn" @click="${this.handlePointsProfileClick}">
              ${this.i18n.t("customer.loyalty.points_profile")}
            </div>
          </div>
        </div>

        <!-- Modale esterna con codice card -->
        <custom-modal
          .open="${this.isModalOpen}"
          @modal-close="${this.closeModal}"
        >
          <div class="modal-wrapper">
            <div class="modal-container">
              <div class="modal-title">
                ${this.i18n.t("customer.loyalty.your_loyalty_card")}
              </div>
              <img
                alt="logo"
                height="80px"
                src="https://b958c5-bf.myshopify.com/cdn/shop/files/Logo_Jaked_Bk.webp?v=1727429681&width=220"
              />

              <br />
              <img
                src="https://api-gateway.jaked.com/api/v1/cll0zl3pe001ppivgkc3r9b9l/loyalty/barcode/${e.cardCode}"
                alt="Barcode"
                style="width: 200px; height: auto;"
              />
              <p class="modal-text">
                ${this.i18n.t("customer.loyalty.present_code")}
              </p>
              <div class="modal-point-container">
                <span>${this.i18n.t("customer.loyalty.your_points")}</span>
                <span> ${e.stats.coins} </span>
              </div>
            </div>
          </div>
        </custom-modal>
      </div>
    `}};P.styles=oi;k([d(F)],P.prototype,"fanizeService",2);k([d(x)],P.prototype,"idpService",2);k([d(_)],P.prototype,"i18n",2);k([y({type:Object})],P.prototype,"user",2);k([f()],P.prototype,"levels",2);k([f()],P.prototype,"isModalOpen",2);P=k([v("user-loyalty-profile")],P);var pi=Object.defineProperty,ui=Object.getOwnPropertyDescriptor,nt=(e,t,i,r)=>{for(var s=r>1?void 0:r?ui(t,i):t,o=e.length-1,n;o>=0;o--)(n=e[o])&&(s=(r?n(t,i,s):n(s))||s);return r&&s&&pi(t,i,s),s};let q=class extends g{constructor(){super(...arguments),this.user=null,this.selectedCode=null,this.selectedCondition=null}handleSelectCode(e){this.selectedCode=e.detail,console.log("Codice selezionato:",this.selectedCode)}handleSelectCondition(e){this.selectedCondition=e.detail,console.log("Condizione selezionata:",this.selectedCondition)}render(){if(!this.user||!this.user.loyalty)return l`<div>${this.i18n.t("customer.loyalty.no_vouchers")}</div>`;const{discountCodes:e,spentDiscountCodes:t}=this.user.loyalty;return l`
        <div>
            <p style="font-size:16px; padding-bottom: 15px">
                ${Dt(this.i18n.t("customer.loyalty.here_you_find_out"))}
            </p>
            <div class="voucher-list">
                <!-- Vouchers Disponibili -->
                ${e!=null&&e.length?l`
                            <b class="title">${this.i18n.t("customer.loyalty.voucher_to_use")}</b>
                            ${e.map(i=>l`
                                        <voucher-card .voucher="${i}"></voucher-card>
                                    `)}
                        `:l`<p>
                            ${this.i18n.t("customer.loyalty.no_active_vouchers")}
                        </p>`}

                <!-- Vouchers Spesi o Scaduti -->
                ${t!=null&&t.length?l`
                            <b class="title">${this.i18n.t("customer.loyalty.voucher_not_available")}</b>
                            ${t.map(i=>l`
                                        <voucher-card
                                                .voucher="${i}"
                                                .isDisabled="${!0}"
                                                @select-code="${this.handleSelectCode}"
                                        ></voucher-card>
                                    `)}
                        `:null}
            </div>
        </div>
    `}};q.styles=A`
    .voucher-list {
      display: flex;
      flex-direction: column;
      gap: 22px;
      width: 100%;
    }
    .title {
      font-size: 16px;
      margin-bottom: 20px;
    }
  `;nt([d(_)],q.prototype,"i18n",2);nt([y({type:Object})],q.prototype,"user",2);nt([f()],q.prototype,"selectedCode",2);nt([f()],q.prototype,"selectedCondition",2);q=nt([v("voucher-list")],q);var hi=Object.defineProperty,fi=Object.getOwnPropertyDescriptor,vt=(e,t,i,r)=>{for(var s=r>1?void 0:r?fi(t,i):t,o=e.length-1,n;o>=0;o--)(n=e[o])&&(s=(r?n(t,i,s):n(s))||s);return r&&s&&hi(t,i,s),s};let et=class extends g{constructor(){super(),this.user=null,window.addEventListener("resize",()=>this.requestUpdate())}isSmallScreen(){return window.innerWidth<=768}async connectedCallback(){super.connectedCallback(),this.user=await this.idpService.me()}render(){const e=this.isSmallScreen();return l`
      <tab-container
        class="tabs-container"
        .tabs=${this.user&&this.user.loyalty!==null?[this.i18n.t("customer.menu.tab-profile"),this.i18n.t("customer.menu.tab-vouchers"),this.i18n.t("customer.menu.tab-loyalty"),this.i18n.t("customer.menu.tab-authentication")]:[this.i18n.t("customer.menu.tab-profile"),this.i18n.t("customer.menu.tab-authentication")]}
      >
        <!-- Scheda Profilo Utente -->
        <div slot="tab-0">
          <div
            style="
                display: flex; 
                gap: ${e?"20px":"60px"};  /* Gap responsivo */
                flex-wrap: wrap; 
                width: 100%; 
                flex-direction: ${e?"column":"row"}; /* Colonna per mobile, riga per desktop */
              "
            class="form-container"
          >
            <!-- Account utente section -->
            <div
              style="
                  flex: 2; 
                  min-width: 0; 
                  width: ${e?"100%":"66.66%"}; /* Larghezza responsive */
                  box-sizing: border-box;
                "
            >
              ${this.user&&this.user.loyalty!==null?l`<div>
                    <user-loyalty-profile .user="${this.user}" />
                  </div>`:""}

              <h6 style="margin-bottom: 25px;">
                ${this.i18n.t("customer.account.account-user")}
              </h6>

              <!-- Form del profilo utente -->
              <user-profile-form .user="${this.user}" />
            </div>

            <!-- Separatore visivo per desktop -->
            <div
              style="
                  border-left: 1px solid #E2E2E2; 
                  height: auto; 
                  align-self: stretch;
                  display: ${e?"none":"block"};
                "
            ></div>

            <!-- Separatore visivo per mobile -->
            <div
              style="
                  border-bottom: 1px solid #E2E2E2; 
                  width: 100%; 
                  display: ${e?"block":"none"};
                  margin: 20px 0;
                "
            ></div>

            <!-- Privacy section -->
            <div
              style="
                  flex: 1; 
                  min-width: 0; 
                  width: ${e?"100%":"33.33%"}; 
                  box-sizing: border-box;
                "
            >
              <h6 style="margin-bottom: 25px;">Privacy</h6>
              <user-privacy-form />
            </div>
          </div>
        </div>

        ${this.user&&this.user.loyalty!==null?l`<div slot="tab-1">
              <voucher-list .user="${this.user}" />
            </div>`:""}
        ${this.user&&this.user.loyalty!==null?l`<div slot="tab-2">
              <loyalty-page />
            </div>`:""}

        <div
          slot=${this.user&&this.user.loyalty!==null?"tab-3":"tab-1"}
        >
          <password-change-form></password-change-form>
        </div>
      </tab-container>
    `}};vt([d(x)],et.prototype,"idpService",2);vt([d(_)],et.prototype,"i18n",2);vt([f()],et.prototype,"user",2);et=vt([v("user-profile"),gt],et);var mi=Object.defineProperty,gi=Object.getOwnPropertyDescriptor,ee=(e,t,i,r)=>{for(var s=r>1?void 0:r?gi(t,i):t,o=e.length-1,n;o>=0;o--)(n=e[o])&&(s=(r?n(t,i,s):n(s))||s);return r&&s&&mi(t,i,s),s};let ut=class extends g{constructor(){super(...arguments),this.open=!1}closeModal(){this.open=!1,this.dispatchEvent(new CustomEvent("modal-close",{detail:{open:!1}}))}render(){return this.open?l`
      <div class="modal-backdrop" @click="${this.closeModal}"></div>
      <div class="modal">
        <button class="close-button" @click="${this.closeModal}">
          &times;
        </button>
        <slot></slot>
      </div>
    `:l``}};ut.styles=A`
    .modal-backdrop {
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: rgba(0, 0, 0, 0.5);
      z-index: 1000;
    }

    .modal {
      position: fixed;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      background-color: white;
      padding: 20px;
      border-radius: 8px;
      max-width: 500px;
      width: 90%;
      z-index: 1001;
      box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
      transition: all 0.3s ease-in-out;
    }

    .close-button {
      position: absolute;
      top: 10px;
      right: 10px;
      background: transparent;
      border: none;
      font-size: 30px;
      color: gray;
      cursor: pointer;
    }

    /* Modale dal basso sugli schermi piccoli */
    @media (max-width: 768px) {
      .modal {
        top: auto;
        bottom: 0;
        left: 50%;
        transform: translate(-50%, 100%);
        border-radius: 12px 12px 0 0;
        animation: slide-up 0.4s ease-in-out forwards;
      }
    }

    /* Animazione per lo scorrimento verso l'alto */
    @keyframes slide-up {
      from {
        transform: translate(-50%, 100%);
      }
      to {
        transform: translate(-50%, 0);
      }
    }
  `;ee([y({type:Boolean})],ut.prototype,"open",2);ut=ee([v("custom-modal")],ut);var yi=Object.defineProperty,bi=Object.getOwnPropertyDescriptor,Lt=(e,t,i,r)=>{for(var s=r>1?void 0:r?bi(t,i):t,o=e.length-1,n;o>=0;o--)(n=e[o])&&(s=(r?n(t,i,s):n(s))||s);return r&&s&&yi(t,i,s),s};let it=class extends g{constructor(){super(...arguments),this.tabs=[],this.activeIndex=0}selectTab(e){this.activeIndex=e}render(){return l`
      <div class="tabs">
        ${this.tabs.map((e,t)=>l`
            <div
              class="tab ${this.activeIndex===t?"active":""}"
              @click=${()=>this.selectTab(t)}
            >
              ${e}
            </div>
          `)}
      </div>
      <div class="content">
        <slot name="tab-${this.activeIndex}"></slot>
      </div>
    `}};it.styles=A`
    .tabs {
      display: flex;
      /*  border-bottom: 1px solid #cccccc; */
      justify-content: flex-start; /* Allineamento a sinistra */
      margin-bottom: 10px;
      gap: 10px; /* Spazio tra i bottoni delle tab */
    }

    .tab {
      cursor: pointer;
      padding: 10px 20px;
      border: 1px solid transparent;
      transition:
        background-color 0.3s ease,
        color 0.3s ease;
    }

    .tab.active {
      border-bottom: 2px solid #f7fc00; /* Colore di accento */
      font-weight: bold;
      background-color: #f7fc00; /* Colore di accento */
      color: #000;
    }

    .tab:hover {
      background-color: #f7fc00; /* Colore di accento */
      color: #000;
    }

    .content {
      padding: 20px;
    }

    /* Media query per dispositivi mobili */
    @media (max-width: 768px) {
      .tabs {
        flex-direction: row;
        overflow-x: auto; /* Scroll orizzontale */
        white-space: nowrap; /* Evita il wrapping dei bottoni */
        -webkit-overflow-scrolling: touch; /* Smoothing per scroll */
      }

      .tab {
        font-size: 14px;
        padding: 8px 15px;
        width: auto;
        flex: 0 0 auto; /* Dimensione automatica per scroll orizzontale */
      }

      .content {
        padding: 15px;
      }
    }
  `;Lt([y({type:Array})],it.prototype,"tabs",2);Lt([y({type:Number})],it.prototype,"activeIndex",2);it=Lt([v("tab-container")],it);const vi=A`
  .voucher-card {
    display: flex;
    justify-content: space-between;
    padding: 20px;
    border: 1px solid #000;
    border-left: none;
    border-right: none;
    align-items: center;
    height: 100%;
  }

  .discount {
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    padding-left: 30px;
    padding-right: 40px;
  }

  .discount span:first-child {
    font-weight: bold;
    font-size: 32px;
  }

  .discount span:last-child {
    font-weight: bold;
    font-size: 16px;
  }

  .info {
    display: flex;
    flex-direction: column;
    padding-left: 25px;
    border-left: 1px solid #000;
    flex-grow: 1;
    gap: 8px;
  }

  .info b {
    font-size: 14px;
  }

  .conditions {
    display: flex;
    gap: 6px;
    font-size: 14px;
  }

  .status {
    display: flex;
    align-items: center;
    gap: 4px;
    font-size: 12px;
    color: green;
  }

  .buttons {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    gap: 10px;
  }

  .button {
    padding: 10px 20px;
    cursor: pointer;
    font-size: 14px;
    text-transform: uppercase;
    font-weight: 600;
    width: 100%;
    text-align: center;
  }

  .copy-btn {
    border: 1px solid #000;
    background-color: #000;
    color: #fff;
  }

  .show-btn {
    border: 1px solid #000;
    color: #000;
    background-color: #fff;
  }

  /* Stili responsive per dispositivi mobili */
  @media screen and (max-width: 768px) {
    .voucher-card {
      flex-direction: column;
      align-items: flex-start;
      padding: 10px;
    }

    .discount {
      flex-direction: row;
      align-items: center;
      justify-content: flex-start;
      padding-left: 0;
      padding-right: 0;
      width: 100%;
      margin-bottom: 20px;
    }

    .discount span {
      text-transform: capitalize;
      font-size: 24px;
      font-weight: bold;
      margin-right: 5px;
    }

    .info {
      width: 100%;
      padding-left: 0;
      border-left: none;
      margin-bottom: 20px;
    }

    .buttons {
      display: flex;
      box-sizing: border-box;
      padding-left: 20px;
      padding-right: 20px;
      padding-bottom: 8px;
      flex-direction: column;
      justify-content: space-between;
      align-items: center;
      width: 100%;
    }

    .discount span:first-child {
      font-weight: bold;
      font-size: 22px;
    }

    .discount span:last-child {
      font-weight: bold;
      font-size: 22px;
    }
  }

  /* modal */

  .modal-container {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    max-width: 350px;
  }

  .modal-title {
    padding-top: 15px;
    font-weight: 600;
    font-size: 22px;
  }

  .modal-point-container {
    width: 100%;
    justify-content: space-between;
    font-weight: 600;
    font-size: 18px;
    display: flex;
    padding: 15px;
    border-top: 1px solid #d3d3d3;
  }

  .modal-wrapper {
    justify-content: center;
    display: flex;
  }

  .modal-text {
    padding-top: 15px;
    text-align: center;
    color: #626266;
  }

  .button.disabled {
    opacity: 0.6;
    cursor: not-allowed;
    pointer-events: none;
  }
`;var _i=Object.defineProperty,$i=Object.getOwnPropertyDescriptor,z=(e,t,i,r)=>{for(var s=r>1?void 0:r?$i(t,i):t,o=e.length-1,n;o>=0;o--)(n=e[o])&&(s=(r?n(t,i,s):n(s))||s);return r&&s&&_i(t,i,s),s};let w=class extends g{constructor(){super(...arguments),this.voucher=null,this.daysRemaining=0,this.formattedExpireDate="",this.copied=!1,this.openCodeModal=!1,this.isDisabled=!1}connectedCallback(){super.connectedCallback(),this.calculateDates()}calculateDates(){if(this.voucher&&this.voucher.expireAt){const e=new Date(this.voucher.expireAt),t=new Date,i=e.getTime()-t.getTime(),r=Math.ceil(i/(1e3*3600*24));this.daysRemaining=r;const s=e.getDate().toString().padStart(2,"0"),o=(e.getMonth()+1).toString().padStart(2,"0"),n=e.getFullYear();this.formattedExpireDate=`${s}/${o}/${n}`}}handleCopyClick(){var e;this.isDisabled||navigator.clipboard.writeText(((e=this.voucher)==null?void 0:e.code)??"").then(()=>{this.copied=!0,setTimeout(()=>{this.copied=!1},3e3)})}get discountSymbol(){var e;return((e=this.voucher)==null?void 0:e.type)==="percentage"?"%":"€"}get maskedCode(){var t;const e=((t=this.voucher)==null?void 0:t.code)||"";if(this.isDisabled){const i=e.length,r=Math.floor(i/4),s=Math.floor(i*3/4);return e.substring(0,r)+"#".repeat(s-r)+e.substring(s)}return e}render(){var e,t,i,r;return l`
      <div class="voucher-card">
        <!-- Percentuale di sconto -->
        <div class="discount">
          <span>${(e=this.voucher)==null?void 0:e.value}${this.discountSymbol}</span>

          <span>${this.i18n.t("customer.loyalty.of_discount")}</span>
        </div>

        <!-- Informazioni del voucher -->
        <div class="info">
          <div>
            ${this.i18n.t("customer.loyalty.discount_code")}
            <b>${this.maskedCode}</b>
          </div>
          <div class="conditions">
            ${Dt(this.i18n.t("customer.loyalty.day_left",{days:`${this.daysRemaining}`}))}

            <a
              target="_blank"
              href="https://tribe.jaked.com/static/regolamento-loyalty-tribe.pdf"
              >${this.i18n.t("customer.loyalty.find_conditions")}</a
            >
          </div>
          <div class="status ${this.isDisabled?"expired":""}">
            ${this.isDisabled?"":l`
                  <img
                    src="https://cdn.shopify.com/s/files/1/0893/8107/7341/files/loyalty-check.svg?v=1729258172"
                    alt="Icona Stato"
                  />
                `}
            <span
              style="${this.isDisabled?"color:firebrick; font-size:14px":"font-size:14px"}"
            >
              ${this.i18n.t("customer.loyalty.find_conditions")}:
              ${this.isDisabled?this.i18n.t("customer.loyalty.expired"):(t=this.voucher)==null?void 0:t.status}
            </span>
          </div>
          <div>
            ${this.i18n.t("customer.loyalty.expires_on")}
            <b>${this.formattedExpireDate}</b>
          </div>
        </div>

        <!-- Pulsanti -->
        <div class="buttons">
          <div
            class="button copy-btn ${this.isDisabled?"disabled":""}"
            @click="${this.isDisabled?null:this.handleCopyClick}"
          >
            ${this.copied?this.i18n.t("customer.loyalty.code_copied"):this.i18n.t("customer.loyalty.copy_code")}
          </div>
          <div
            class="button show-btn ${this.isDisabled?"disabled":""}"
            @click="${this.isDisabled?null:()=>this.openCodeModal=!0}"
          >
            Mostra Codice
          </div>
        </div>

        <!-- Modale esterna con codice card -->
        ${this.isDisabled?"":l`
              <custom-modal
                .open="${this.openCodeModal}"
                @modal-close="${()=>this.openCodeModal=!1}"
              >
                <div class="modal-wrapper">
                  <div class="modal-container">
                    <div class="modal-title">
                      ${(i=this.voucher)==null?void 0:i.value}${this.discountSymbol}
                      ${this.i18n.t("customer.loyalty.of_discount")}
                    </div>
                    <br />
                    <img
                      src="https://api-gateway.jaked.com/api/v1/cll0zl3pe001ppivgkc3r9b9l/loyalty/barcode/$${(r=this.voucher)==null?void 0:r.code}"
                      alt="Barcode"
                      style="width: 200px; height: auto;"
                    />

                    <p class="modal-text">
                      ${this.i18n.t("customer.loyalty.barcode_to_use_voucher")}
                    </p>

                    <div
                      style="width: 300px; margin-top: 15px"
                      class="button copy-btn"
                      @click="${this.handleCopyClick}"
                    >
                      ${this.copied?"Codice Copiato":"Copia Codice"}
                    </div>

                    <p class="modal-text">
                      ${this.i18n.t("customer.loyalty.terms_voucher")}
                      <a
                        href="https://tribe.jaked.com/static/regolamento-loyalty-tribe.pdf"
                        target="_blank"
                        >tribe.jaked.com/static/regolamento-loyalty-tribe.pdf</a
                      >.
                    </p>
                  </div>
                </div>
              </custom-modal>
            `}
      </div>
    `}};w.styles=vi;z([d(_)],w.prototype,"i18n",2);z([y({type:Object})],w.prototype,"voucher",2);z([y({type:Number})],w.prototype,"daysRemaining",2);z([y({type:String})],w.prototype,"formattedExpireDate",2);z([y({type:Boolean})],w.prototype,"copied",2);z([y({type:Boolean})],w.prototype,"openCodeModal",2);z([y({type:Boolean})],w.prototype,"isDisabled",2);w=z([v("voucher-card")],w);const xi=A`
  :host {
    display: block;
    font-family: Arial, sans-serif;
    margin: 0;
    padding: 0;
  }

  .loyalty-container {
    margin: 0 auto;
    padding: 20px;
    padding-top: 0;
  }

  h1 {
    font-size: 2.5em;
    margin-bottom: 20px;
  }

  p {
    font-size: 1.1rem;
  }

  .overline {
    font-size: 0.875rem;
    font-weight: bold;
    color: #0353a4;
    margin-bottom: 0.5em;
  }

  .subtitle {
    line-height: 1.2;
    margin-bottom: 1em;
  }

  .title {
    font-size: 1.6em;
    font-weight: bold;
    margin-top: 1em;
  }

  .how-to-earn,
  .level-up,
  .app-promotion {
    margin-top: 40px;
  }

  .steps {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    margin-top: 20px;
    gap: 20px;
  }

  .levels {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    margin-top: 20px;
    gap: 30px;
  }

  .step {
    border: 1px solid #000;
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    flex: 1 1 calc(25% - 80px);
    padding: 20px;
  }

  .step-number-container {
    display: flex;
    padding-top: 10px;
    align-items: center;
  }

  .level {
    flex: 1 1 calc(25% - 20px);
    border: 1px solid #000;
    padding: 15px;
    text-align: center;
    box-sizing: border-box;
  }

  .step img,
  .level img {
    width: 100%;
    height: auto;
    object-fit: contain;
    margin: 15px 0;
  }

  .step-number {
    font-weight: bold;
    font-size: 2.2em;
    text-align: left;
    padding-left: 10px;
  }

  .step-text {
    font-size: 1.1em;
    color: #333;
    text-align: justify;
    padding-left: 10px;
  }

  .level {
    background: linear-gradient(180deg, #0353a4, #000);
    color: #fff;
    min-height: 600px;
    max-width: 450px;
    flex: 1 1 calc(33% - 20px);
  }

  .card-title {
    padding-top: 20px;
    padding-bottom: 10px;
    font-size: 1.2em;
  }

  .row-drop {
    text-align: left;
    display: flex;
    justify-content: center;
    align-items: center;
    padding-bottom: 20px;
  }

  .row-drop img {
    margin-right: 10px;
  }

  .p-drop {
    font-size: 1.2em;
    margin: auto 0;
  }

  .text-card {
    padding: 0 10px;
  }

  .row-card {
    text-align: left;
    display: flex;
    margin-bottom: 10px;
  }

  .column-card {
    padding-top: 10px;
    padding-bottom: 10px;
  }

  .level-number {
    padding-right: 10px;
    font-size: 2.1em;
    font-weight: 600;
    color: #f7fc00;
    text-shadow: 0px 0px 4px #f7fc00;
    padding-top: 14px;
  }

  .level-subtitle {
    font-size: 1.4em;
    margin-bottom: 0px;
    font-weight: bold;
  }

  .level-descr {
    font-size: 0.9em;
  }

  .line {
    border-top: 0.5px solid #fff;
    margin-bottom: 10px;
  }

  .app-promotion {
    display: flex;
    gap: 22px;
    align-items: center;
  }

  .app-col {
    display: flex;
    flex-direction: column;
    flex: 1;
  }

  .app-col img {
    max-width: 100%;
    height: auto;
  }

  .app-links {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 16px;
  }

  .app-links img {
    width: 180px;
    height: auto;
    margin-bottom: 20px;
  }

  .app-buttons {
    display: flex;
    flex-direction: column;
    gap: 10px;
  }

  .app-buttons a img {
    width: 150px;
    height: auto;
  }

  .phone {
    max-width: 100%;
    height: auto;
    margin-top: 20px;
  }

  @media (max-width: 768px) {
    .app-promotion {
      flex-direction: column;
    }

    .app-col {
      align-items: center;
      text-align: center;
    }

    .app-links {
      display: flex;
      align-items: center;
    }

    .app-buttons {
      flex-direction: row;
      flex-wrap: wrap;
      justify-content: center;
    }

    .app-buttons a img {
      width: 120px;
      margin: 5px;
    }

    .phone {
      margin-top: 20px;
    }
  }
`,wi=[{title:"LIVELLO 1",imgSrc:"https://cdn.shopify.com/s/files/1/0893/8107/7341/files/style-seeker___ec609a87881e588dd8bd4b29f9d15047.svg?v=1728338575",alt:"Style Seeker",dropRange:"da 0 a 299 Gocce",benefits:[{number:"01.",subtitle:"Sconto 5%",description:"Valido su tutti i tuoi acquisti su Jaked.com. Verrà applicato automaticamente al check-out. Sconto non cumulabile con altre promo, buoni sconto e/o saldi."},{number:"02.",subtitle:"Trasforma i tuoi acquisti in gocce",description:"Gli acquisti effettuati sul sito www.jaked.com si trasformano in punti goccia, leggi il regolamento per maggiori informazioni."}]},{title:"LIVELLO 2",imgSrc:"https://cdn.shopify.com/s/files/1/0893/8107/7341/files/game-insider___9776fc0cd4535565ca4cbed1bcb4878c.svg?v=1728338575",alt:"Game Insider",dropRange:"da 300 a 599 Gocce",benefits:[{number:"01.",subtitle:"Sconto 10%",description:"Valido su tutti i tuoi acquisti su Jaked.com. Verrà applicato automaticamente al check-out. Sconto non cumulabile con altre promo, buoni sconto e/o saldi."},{number:"02.",subtitle:"Free shipping",description:"Spedizione gratuita sul sito www.jaked.com su ordine minimo di 44,90€"},{number:"03.",subtitle:"Trasforma i tuoi acquisti in gocce",description:"Gli acquisti effettuati sul sito www.jaked.com si trasformano in punti goccia, leggi il regolamento per maggiori informazioni."}]},{title:"LIVELLO 3",imgSrc:"https://cdn.shopify.com/s/files/1/0893/8107/7341/files/trend-setter___3b5f63d3cf1ef4c63cf66e5f72378fc8.svg?v=1728399400",alt:"Trend Setter",dropRange:"da 600 Gocce",benefits:[{number:"01.",subtitle:"Sconto 15%",description:"Valido su tutti i tuoi acquisti su Jaked.com. Verrà applicato automaticamente al check-out. Sconto non cumulabile con altre promo, buoni sconto e/o saldi."},{number:"02.",subtitle:"Free shipping",description:"Spedizione gratuita su tutti gli acquisti effettuati su Jaked.com"},{number:"03.",subtitle:"Trasforma i tuoi acquisti in gocce",description:"Gli acquisti effettuati sul sito www.jaked.com si trasformano in punti goccia, leggi il regolamento per maggiori informazioni."}]}],Si=[{imgSrc:"https://cdn.shopify.com/s/files/1/0893/8107/7341/files/card-1___6576f9480da2463b85bd71319ff44d31.svg?v=1728338576",alt:"Step 1",number:"01.",title:"Registrati e accedi",text:"a 'Jaked Tribe'"},{imgSrc:"https://cdn.shopify.com/s/files/1/0893/8107/7341/files/card-2___414f26d609262c8e511baf1a5f1927e8.svg?v=1728338574",alt:"Step 2",number:"02.",title:"Completa le missioni",text:"per ottenere i tuoi primi punti"},{imgSrc:"https://cdn.shopify.com/s/files/1/0893/8107/7341/files/card-3___5d0f9dd7091fd067f32f8652dd140aab.svg?v=1728338575",alt:"Step 3",number:"03.",title:"Accumula punti goccia",text:"all'interno del tuo profilo"},{imgSrc:"https://cdn.shopify.com/s/files/1/0893/8107/7341/files/card-4___64c27453debf0b30b18e6e48156c4209.svg?v=1728338576",alt:"Step 4",number:"04.",title:"Scala la classifica",text:"e ottieni i benefit pensati per te"}];var Ci=Object.defineProperty,Pi=Object.getOwnPropertyDescriptor,Ai=(e,t,i,r)=>{for(var s=r>1?void 0:r?Pi(t,i):t,o=e.length-1,n;o>=0;o--)(n=e[o])&&(s=(r?n(t,i,s):n(s))||s);return r&&s&&Ci(t,i,s),s};let At=class extends g{render(){return l`
      <div class="loyalty-container">
        <p>
          <b>Tuffati nella Jaked Tribe e accumula punti!</b> Jaked Tribe è la
          nostra nuova community volta a valorizzare e premiare la tua fedeltà.
        </p>
        <p>
          In Jaked Tribe potrai giocare e compiere missioni, sfidando gli altri
          utenti e accumulando punti goccia grazie ai quali scalerai i livelli
          ed otterrai fantastici benefit.
        </p>
        <p>Mettiti alla prova! Sei pronto a giocare con noi?</p>

        <!-- Sezione Come Guadagnare -->
        <section class="how-to-earn">
          <p class="overline">CHE COSA OTTERAI</p>
          <div class="title">Guadagna punti goccia</div>
          <p class="subtitle">Sfida altri utenti e scala la classifica.</p>
          <div class="steps">
            ${Si.map(e=>l`
                <div class="step">
                  <img src="${e.imgSrc}" alt="${e.alt}" />
                  <div class="step-number-container">
                    <div class="step-number">${e.number}</div>
                    <div class="step-text">
                      <b>${e.title}</b><br />
                      ${e.text}
                    </div>
                  </div>
                </div>
              `)}
          </div>
        </section>

        <!-- Sezione Level Up -->
        <section class="level-up">
          <p class="overline">SBLOCCA VANTAGGI ESCLUSIVI</p>
          <div class="title">Level up</div>
          <p class="subtitle">Scala i livelli ed ottieni fantastici benefit.</p>

          <div class="levels">
            ${wi.map(e=>l`
                <div class="level">
                  <div class="card-title">${e.title}</div>
                  <img
                    src="${e.imgSrc}"
                    alt="${e.alt}"
                    style="width:260px"
                  />
                  <div class="row-drop">
                    <img
                      src="https://cdn.shopify.com/s/files/1/0893/8107/7341/files/gocce___88128dcd7eb9c6dd7c5059406249bea6.svg?v=1728338576"
                      alt="Drop"
                      style="height:40px;width:40px"
                    />
                    <p class="p-drop">${e.dropRange}</p>
                  </div>
                  <div class="text-card">
                    ${e.benefits.map((t,i)=>l`
                        <div class="row-card">
                          <div class="column-card">
                            <div class="level-number">${t.number}</div>
                          </div>
                          <div class="column-card">
                            <p class="level-subtitle">${t.subtitle}</p>
                            <p class="level-descr">${t.description}</p>
                          </div>
                        </div>
                        ${i<e.benefits.length-1?l`<div class="line"></div>`:""}
                      `)}
                  </div>
                </div>
              `)}
          </div>
        </section>

        <!-- Sezione Promozione App -->

        <section class="app-promotion">
          <div class="app-col">
            <div class="title">Jaked Tribe - Official App</div>
            <p style="font-size:18px">
              Scarica la nuova App ufficiale di Jaked e immergiti nel nostro
              mondo direttamente dal tuo smartphone: completa le sfide e
              accumula punti goccia per conquistare i benefit pensati per te,
              conquistarli è veramente semplice. È sufficiente inserire le tue
              credenziali e completare tutte le nostre missioni.
            </p>
            <div class="app-links">
              <img
                target="_blank"
                src="https://cdn.shopify.com/s/files/1/0893/8107/7341/files/QR-Code_eb4151e0-d9e0-4742-9dd0-4e48e3eaaab8___d42ed26635630062534d6c7f3c41cc95.webp?v=1728338574"
                alt="QR code"
              />
              <div class="app-buttons">
                <a
                  target="_blank"
                  href="https://play.google.com/store/apps/details?id=com.jaked.app"
                >
                  <img
                    src="https://cdn.shopify.com/s/files/1/0893/8107/7341/files/google-play___3f17720a73506e270035646579e608e6.svg?v=1728338574"
                    alt="Google Play"
                  />
                </a>
                <a
                  target="_blank"
                  href="https://apps.apple.com/us/app/jaked-tribe-official-app/id1659367989"
                >
                  <img
                    src="https://cdn.shopify.com/s/files/1/0893/8107/7341/files/app-store___10a02e95baee3389529ee692b8761c9b.svg?v=1728338574"
                    alt="App Store"
                  />
                </a>
              </div>
            </div>
          </div>
          <div class="app-col">
            <img
              style="max-height:600px"
              class="phone"
              src="https://cdn.shopify.com/s/files/1/0893/8107/7341/files/phone.svg?v=1728401533"
              alt="Jaked App"
            />
          </div>
        </section>
      </div>
    `}};At.styles=xi;At=Ai([v("loyalty-page")],At);var Ei=Object.defineProperty,Oi=Object.getOwnPropertyDescriptor,ie=(e,t,i,r)=>{for(var s=r>1?void 0:r?Oi(t,i):t,o=e.length-1,n;o>=0;o--)(n=e[o])&&(s=(r?n(t,i,s):n(s))||s);return r&&s&&Ei(t,i,s),s};let ht=class{async request(e,t){const i=this.configService.get("API_GATEWAY");try{const r=await fetch(`${i}${e}`,{credentials:"include",headers:{"Content-Type":"application/json"},...t}),s=await r.json();return!r.ok&&s.error?null:s.data}catch(r){return console.error(`Error during request to ${e}:`,r),null}}async getWishlistProducts(e){return this.request(`/giftcard/${e}/credit`,{method:"GET"})}async validateGiftCardBrand(e,t){try{if(!e||e.trim()==="")return!1;const i=t.toLowerCase();return i==="miriade"?e.startsWith("320")||e.startsWith("444")||e.startsWith("448"):i==="jaked"?e.startsWith("321")||e.startsWith("445"):i==="v73"?e.startsWith("446"):!1}catch(i){return console.error(`Error validating gift card ${e} for brand ${t}:`,i),!1}}};ie([d(R)],ht.prototype,"configService",2);ht=ie([D],ht);var ji=Object.defineProperty,Ti=Object.getOwnPropertyDescriptor,E=(e,t,i,r)=>{for(var s=r>1?void 0:r?Ti(t,i):t,o=e.length-1,n;o>=0;o--)(n=e[o])&&(s=(r?n(t,i,s):n(s))||s);return r&&s&&ji(t,i,s),s};const Di={Created:"Creato/Non attivo",Active:"Attivato",Hold:"In sospeso",Consumed:"Consumato",Cancelled:"Annullato"};let $=class extends g{constructor(){super(...arguments),this.code="",this.balance=null,this.giftCardStatus=null,this.expirationDate=null,this.errorMessage=null,this.isLoading=!1}handleInput(e){const t=e.target;this.code=t.value}async handleSubmit(e){if(e.preventDefault(),this.isLoading=!0,this.errorMessage=null,this.balance=null,this.giftCardStatus=null,this.expirationDate=null,!this.code){this.errorMessage="Inserisci un codice valido.",this.isLoading=!1;return}if(!await this.giftcardService.validateGiftCardBrand(this.code,"jaked")){this.errorMessage="Questo codice non è di una Gift Card Jaked",this.isLoading=!1;return}const i=await this.giftcardService.getWishlistProducts(this.code);i?(this.balance=i.balanceValue,this.giftCardStatus=i.giftCardStatus,this.expirationDate=i.expirationDate):this.errorMessage="Non abbiamo trovato la carta.",this.isLoading=!1}render(){return l`
      <div class="giftcard-container">
        <div class="intro-text">
          Verifica il saldo e lo stato della tua Gift Card o eGift Card
          inserendo il codice qui sotto.
        </div>
        <form @submit=${this.handleSubmit} class="giftcard-form">
          <div class="form-row">
            <input
              id="giftcard-code"
              type="text"
              .value=${this.code}
              @input=${this.handleInput}
              placeholder="Inserisci il codice"
              required
            />
            <button type="submit" ?disabled=${this.isLoading}>
              ${this.isLoading?"Caricamento...":"Verifica Saldo"}
            </button>
          </div>
        </form>

        ${this.errorMessage?l`<div class="error-message">${this.errorMessage}</div>`:this.balance!==null?l` <table class="giftcard-table">
                <tr>
                  <td>Saldo</td>
                  <td>${this.balance} €</td>
                </tr>
                <tr>
                  <td>Data di scadenza</td>
                  <td>
                    ${new Date(this.expirationDate).toLocaleDateString()}
                  </td>
                </tr>
                <tr>
                  <td>Stato</td>
                  <td>
                    ${this.giftCardStatus?Di[this.giftCardStatus]:""}
                  </td>
                </tr>
              </table>`:""}
      </div>
    `}};$.styles=A`
    .giftcard-container {
      width: 100%;
      box-sizing: border-box;
    }

    .intro-text {
      font-size: 16px;
      text-align: center;
      margin-bottom: 20px;
      color: #333;
    }

    .giftcard-form {
      width: 100%;
      margin: 0 auto;
    }

    .form-row {
      display: flex;
      flex-direction: column;
      width: 100%;
      gap: 10px;
    }

    input {
      width: 100%;
      padding: 10px;
      font-size: 16px;
      border: 1px solid #ccc;
      box-sizing: border-box;
    }

    button {
      padding: 10px 20px;
      font-size: 16px;
      background-color: black;
      color: white;
      border: none;
      border-radius: 4px;
      cursor: pointer;
      white-space: nowrap;
    }

    button:disabled {
      background-color: #555;
      cursor: not-allowed;
    }

    .error-message {
      padding: 15px;
      margin-top: 15px;
      background-color: #fee;
      border: 1px solid #fcc;
      border-radius: 4px;
      color: #c00;
      font-size: 14px;
    }

    .giftcard-table {
      width: 100%;
      margin: 20px auto;
      border-collapse: collapse;
      background: white;
      border-radius: 8px;
      box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
      box-sizing: border-box;
    }

    .giftcard-table td {
      padding: 12px;
      border-bottom: 1px solid #ddd;
      font-size: 16px;
      color: #333;
    }

    .giftcard-table tr:last-child td {
      border-bottom: none;
    }

    @media only screen and (min-width: 768px) {
      .form-row {
        flex-direction: row;
        align-items: center;
      }
      input {
        flex-grow: 1;
      }
      button {
        width: auto;
        margin-left: 10px;
      }
    }
  `;E([d(_)],$.prototype,"i18n",2);E([d(ht)],$.prototype,"giftcardService",2);E([f()],$.prototype,"code",2);E([f()],$.prototype,"balance",2);E([f()],$.prototype,"giftCardStatus",2);E([f()],$.prototype,"expirationDate",2);E([f()],$.prototype,"errorMessage",2);E([f()],$.prototype,"isLoading",2);$=E([v("giftcard-credit")],$);const Li=new _;document.addEventListener("DOMContentLoaded",()=>{const e=document.getElementById("contact_form");e&&(e.removeAttribute("action"),e.addEventListener("submit",async t=>{t.preventDefault(),t.stopPropagation();const i=new FormData(e),r={firstName:i.get("contact[name]"),lastName:i.get("contact[cognome]"),email:i.get("contact[email]"),phone:i.get("contact[telefono-facoltativo]")||"",country:"IT",language:"Italian",orderNumber:i.get("contact[numero-ordine-facoltativo]")||"",description:i.get("contact[body]"),subject:i.get("contact[oggetto]"),recordTypeId:"01268000000woByAAI"};try{const s=await fetch("https://api-mdw.jaked.com/v1/jaked/email/contactus",{method:"POST",headers:{"Content-Type":"application/json"},body:JSON.stringify(r)});if(!s.ok)throw new Error(`Errore ${s.status}: ${s.statusText}`);b(Li.t("contact.form.post_success")),e.reset()}catch(s){console.error("❌ Errore durante l'invio:",s)}}))});document.addEventListener("DOMContentLoaded",()=>{new MutationObserver(()=>{const t=document.querySelector('label.filter-group__item[data-tag="0"]');t&&(t.style.display="none")}).observe(document.body,{childList:!0,subtree:!0})});const zi=["promo"];function Ii(){const t=window.location.pathname.match(/\/collections\/([^\/\?]+)/);return t?t[1]:null}function se(){const e=["in-season","last-chance"];document.querySelectorAll(".filter-group").forEach(t=>{var r;const i=((r=t.textContent)==null?void 0:r.trim())||"";if(e.some(s=>i.includes(s))){const s=t.closest(".filter-group");s&&(s.style.display="none")}}),document.querySelectorAll(".filter-group__applied-item").forEach(t=>{var r;const i=t.querySelector(".filter-group__heading__text");if(i){const s=((r=i.textContent)==null?void 0:r.trim())||"";if(e.some(o=>s.includes(o))){const o=t.closest(".filter-group");o&&(o.style.display="none")}}})}function Mi(){se();const e=Ii(),t=new URL(window.location.href);if(!e)return;const i=zi.includes(e)?"last-chance":"in-season";t.searchParams.get("filter.v.m.custom.tag_variante")!==i&&(t.searchParams.set("filter.v.m.custom.tag_variante",i),console.log("inserisco il filtro",t.href),window.location.href=t.toString())}function Ni(){const e=new MutationObserver(i=>{let r=!1;i.forEach(s=>{s.type==="childList"&&s.addedNodes.forEach(o=>{var n,c;if(o.nodeType===Node.ELEMENT_NODE){const a=o;((n=a.classList)!=null&&n.contains("filter-group")||(c=a.classList)!=null&&c.contains("filter-group__applied-item")||a.querySelector(".filter-group")||a.querySelector(".filter-group__applied-item"))&&(r=!0)}})}),r&&se()}),t=document.querySelector(".filters")||document.querySelector('[class*="filter"]')||document.body;e.observe(t,{childList:!0,subtree:!0})}document.addEventListener("DOMContentLoaded",()=>{Mi(),Ni()});
